// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseURL: `${string}://${string}/api` | (string & {});
};

/**
 * ALQ
 */
export enum ALQ_api {
    GRAT = "GRAT",
    IGLR = "IGLR",
    TGLR = "TGLR",
    PUMP = "PUMP",
    COMP = "COMP",
    DENO = "DENO",
    DENG = "DENG",
    BEAN = "BEAN",
    "''" = "''",
}

/**
 * AssetInfo
 */
export type AssetInfo_api = {
    /**
     * Name
     */
    name: string;
};

/**
 * B64FloatArray
 */
export type B64FloatArray_api = {
    /**
     * Element Type
     */
    element_type: "float32" | "float64";
    /**
     * Data B64Str
     */
    data_b64str: string;
};

/**
 * B64UintArray
 */
export type B64UintArray_api = {
    /**
     * Element Type
     */
    element_type: "uint8" | "uint16" | "uint32" | "uint64";
    /**
     * Data B64Str
     */
    data_b64str: string;
};

/**
 * Body_post_get_aggregated_per_realization_inplace_table_data
 */
export type BodyPostGetAggregatedPerRealizationInplaceTableData_api = {
    /**
     * Indices With Values
     *
     * Selected indices and wanted values
     */
    indices_with_values: Array<InplaceVolumesIndexWithValues_api>;
};

/**
 * Body_post_get_aggregated_statistical_inplace_table_data
 */
export type BodyPostGetAggregatedStatisticalInplaceTableData_api = {
    /**
     * Indices With Values
     *
     * Selected indices and wanted values
     */
    indices_with_values: Array<InplaceVolumesIndexWithValues_api>;
};

/**
 * Body_post_get_polyline_intersection
 */
export type BodyPostGetPolylineIntersection_api = {
    /**
     * Polyline Utm Xy
     */
    polyline_utm_xy: Array<number>;
};

/**
 * Body_post_get_sample_surface_in_points
 */
export type BodyPostGetSampleSurfaceInPoints_api = {
    sample_points: PointSetXY_api;
    /**
     * Surface Attribute
     *
     * Surface attribute
     */
    surface_attribute: TagNameAttribute_api | StdResAttribute_api;
};

/**
 * Body_post_get_seismic_fence
 */
export type BodyPostGetSeismicFence_api = {
    polyline: SeismicFencePolyline_api;
};

/**
 * Body_post_get_surface_intersection
 */
export type BodyPostGetSurfaceIntersection_api = {
    cumulative_length_polyline: SurfaceIntersectionCumulativeLengthPolyline_api;
};

/**
 * Body_post_get_well_trajectories_formation_segments
 */
export type BodyPostGetWellTrajectoriesFormationSegments_api = {
    /**
     * Well Trajectories
     */
    well_trajectories: Array<WellTrajectory_api>;
};

/**
 * BoundingBox2d
 */
export type BoundingBox2d_api = {
    /**
     * Min X
     */
    min_x: number;
    /**
     * Min Y
     */
    min_y: number;
    /**
     * Max X
     */
    max_x: number;
    /**
     * Max Y
     */
    max_y: number;
};

/**
 * BoundingBox3d
 *
 * Bounding box for a 3D grid geometry
 */
export type BoundingBox3d_api = {
    /**
     * Xmin
     */
    xmin: number;
    /**
     * Ymin
     */
    ymin: number;
    /**
     * Zmin
     */
    zmin: number;
    /**
     * Xmax
     */
    xmax: number;
    /**
     * Ymax
     */
    ymax: number;
    /**
     * Zmax
     */
    zmax: number;
};

/**
 * CaseInfo
 */
export type CaseInfo_api = {
    /**
     * Uuid
     */
    uuid: string;
    /**
     * Name
     */
    name: string;
    /**
     * Status
     */
    status: string;
    /**
     * User
     */
    user: string;
    /**
     * Updatedatutcms
     */
    updatedAtUtcMs: number;
    /**
     * Description
     */
    description: string;
    /**
     * Modelname
     */
    modelName: string | null;
    /**
     * Modelrevision
     */
    modelRevision: string | null;
    /**
     * Ensembles
     */
    ensembles: Array<EnsembleInfo_api>;
};

/**
 * Completions
 */
export type Completions_api = {
    /**
     * Sortedcompletiondateindices
     */
    sortedCompletionDateIndices: Array<number>;
    /**
     * Open
     */
    open: Array<number>;
    /**
     * Shut
     */
    shut: Array<number>;
    /**
     * Khmean
     */
    khMean: Array<number>;
    /**
     * Khmin
     */
    khMin: Array<number>;
    /**
     * Khmax
     */
    khMax: Array<number>;
};

/**
 * DatedFlowNetwork
 */
export type DatedFlowNetwork_api = {
    /**
     * Dates
     */
    dates: Array<string>;
    network: NetworkNode_api;
};

/**
 * DerivedVectorInfo
 */
export type DerivedVectorInfo_api = {
    type: DerivedVectorType_api;
    /**
     * Sourcevector
     */
    sourceVector: string;
};

/**
 * DerivedVectorType
 */
export enum DerivedVectorType_api {
    PER_DAY = "PER_DAY",
    PER_INTVL = "PER_INTVL",
}

/**
 * DiscreteValueMetadata
 *
 * Holds information that describes how a discrete curve value should be presented to the user.
 */
export type DiscreteValueMetadata_api = {
    /**
     * Code
     */
    code: number;
    /**
     * Identifier
     */
    identifier: string;
    /**
     * Rgbcolor
     */
    rgbColor: [number, number, number];
};

/**
 * EnsembleDetails
 */
export type EnsembleDetails_api = {
    /**
     * Name
     */
    name: string;
    /**
     * Assetname
     */
    assetName: string;
    /**
     * Fieldidentifiers
     */
    fieldIdentifiers: Array<string>;
    /**
     * Casename
     */
    caseName: string;
    /**
     * Caseuuid
     */
    caseUuid: string;
    /**
     * Realizations
     */
    realizations: Array<number>;
    /**
     * Stratigraphiccolumnidentifier
     */
    stratigraphicColumnIdentifier: string;
    /**
     * Standardresults
     */
    standardResults: Array<string>;
    /**
     * Fipregions
     */
    fipRegions: Array<FipRegion_api>;
};

/**
 * EnsembleIdent
 */
export type EnsembleIdent_api = {
    /**
     * Caseuuid
     */
    caseUuid: string;
    /**
     * Ensemblename
     */
    ensembleName: string;
};

/**
 * EnsembleInfo
 */
export type EnsembleInfo_api = {
    /**
     * Name
     */
    name: string;
    /**
     * Realizationcount
     */
    realizationCount: number;
    /**
     * Standardresults
     */
    standardResults: Array<string>;
};

/**
 * EnsembleParameter
 *
 * Description/data for a single parameter in an ensemble
 */
export type EnsembleParameter_api = {
    /**
     * Name
     */
    name: string;
    /**
     * Islogarithmic
     */
    isLogarithmic: boolean;
    /**
     * Isdiscrete
     */
    isDiscrete: boolean;
    /**
     * Isconstant
     */
    isConstant: boolean;
    /**
     * Isnumerical
     */
    isNumerical: boolean;
    /**
     * Groupname
     */
    groupName?: string | null;
    /**
     * Descriptivename
     */
    descriptiveName?: string | null;
    /**
     * Realizations
     */
    realizations: Array<number>;
    /**
     * Values
     */
    values: Array<number> | Array<number> | Array<string>;
};

/**
 * EnsembleParametersAndSensitivities
 *
 * Description/data for all parameters and sensitivities in an ensemble
 */
export type EnsembleParametersAndSensitivities_api = {
    /**
     * Parameters
     */
    parameters: Array<EnsembleParameter_api>;
    /**
     * Sensitivities
     */
    sensitivities: Array<EnsembleSensitivity_api>;
    /**
     * Nonstandardparameterswarning
     */
    nonStandardParametersWarning?: string | null;
};

/**
 * EnsembleSensitivity
 *
 * Description/data for a single sensitivity in an ensemble
 */
export type EnsembleSensitivity_api = {
    /**
     * Name
     */
    name: string;
    type: SensitivityType_api;
    /**
     * Cases
     */
    cases: Array<EnsembleSensitivityCase_api>;
};

/**
 * EnsembleSensitivityCase
 *
 * Description/data for a single sensitivity case in an ensemble
 */
export type EnsembleSensitivityCase_api = {
    /**
     * Name
     */
    name: string;
    /**
     * Realizations
     */
    realizations: Array<number>;
};

/**
 * FenceMeshSection
 */
export type FenceMeshSection_api = {
    vertices_uz_b64arr: B64FloatArray_api;
    poly_indices_b64arr: B64UintArray_api;
    vertices_per_poly_b64arr: B64UintArray_api;
    poly_source_cell_indices_b64arr: B64UintArray_api;
    poly_props_b64arr: B64FloatArray_api;
    /**
     * Start Utm X
     */
    start_utm_x: number;
    /**
     * Start Utm Y
     */
    start_utm_y: number;
    /**
     * End Utm X
     */
    end_utm_x: number;
    /**
     * End Utm Y
     */
    end_utm_y: number;
};

/**
 * FieldInfo
 */
export type FieldInfo_api = {
    /**
     * Fieldidentifier
     */
    fieldIdentifier: string;
};

/**
 * FipRegion
 */
export type FipRegion_api = {
    /**
     * Fipnumber
     */
    fipNumber: number;
    /**
     * Zone
     */
    zone: string;
    /**
     * Region
     */
    region: string;
};

/**
 * FlowNetworkData
 */
export type FlowNetworkData_api = {
    /**
     * Edgemetadatalist
     */
    edgeMetadataList: Array<FlowNetworkMetadata_api>;
    /**
     * Nodemetadatalist
     */
    nodeMetadataList: Array<FlowNetworkMetadata_api>;
    /**
     * Datednetworks
     */
    datedNetworks: Array<DatedFlowNetwork_api>;
};

/**
 * FlowNetworkMetadata
 */
export type FlowNetworkMetadata_api = {
    /**
     * Key
     */
    key: string;
    /**
     * Label
     */
    label: string;
    /**
     * Unit
     */
    unit?: string | null;
};

/**
 * FlowNetworkPerTreeType
 */
export type FlowNetworkPerTreeType_api = {
    /**
     * Tree Type Flow Network Map
     */
    tree_type_flow_network_map: {
        [key: string]: FlowNetworkData_api;
    };
};

/**
 * FlowRateType
 */
export enum FlowRateType_api {
    OIL = "OIL",
    LIQ = "LIQ",
    GAS = "GAS",
    WG = "WG",
    TM = "TM",
    WAT = "WAT",
}

/**
 * FormationSegment
 *
 * Segment of a formation defined by top and bottom surface.
 *
 * The formation segment is defined by the md (measured depth) value along the well trajectory,
 * at enter and exit of the formation.
 */
export type FormationSegment_api = {
    /**
     * Mdenter
     */
    mdEnter: number;
    /**
     * Mdexit
     */
    mdExit: number;
};

/**
 * Frequency
 */
export enum Frequency_api {
    DAILY = "DAILY",
    WEEKLY = "WEEKLY",
    MONTHLY = "MONTHLY",
    QUARTERLY = "QUARTERLY",
    YEARLY = "YEARLY",
}

/**
 * GFR
 */
export enum GFR_api {
    GOR = "GOR",
    GLR = "GLR",
    OGR = "OGR",
    MMW = "MMW",
}

/**
 * GraphUser
 */
export type GraphUser_api = {
    /**
     * Id
     */
    id: string;
    /**
     * Principal Name
     */
    principal_name: string;
    /**
     * Display Name
     */
    display_name: string;
    /**
     * Email
     */
    email: string;
};

/**
 * GraphUserPhoto
 */
export type GraphUserPhoto_api = {
    /**
     * Avatar B64Str
     */
    avatar_b64str?: string | null;
};

/**
 * Grid3dDimensions
 *
 * Specification of a 3D grid dimensions
 */
export type Grid3dDimensions_api = {
    /**
     * I Count
     */
    i_count: number;
    /**
     * J Count
     */
    j_count: number;
    /**
     * K Count
     */
    k_count: number;
    /**
     * Subgrids
     */
    subgrids: Array<Grid3dZone_api>;
};

/**
 * Grid3dGeometry
 */
export type Grid3dGeometry_api = {
    polys_b64arr: B64UintArray_api;
    points_b64arr: B64FloatArray_api;
    poly_source_cell_indices_b64arr: B64UintArray_api;
    /**
     * Origin Utm X
     */
    origin_utm_x: number;
    /**
     * Origin Utm Y
     */
    origin_utm_y: number;
    /**
     * Xmin
     */
    xmin: number;
    /**
     * Xmax
     */
    xmax: number;
    /**
     * Ymin
     */
    ymin: number;
    /**
     * Ymax
     */
    ymax: number;
    /**
     * Zmin
     */
    zmin: number;
    /**
     * Zmax
     */
    zmax: number;
};

/**
 * Grid3dInfo
 *
 * Metadata for a 3D grid model, including its properties and geometry
 */
export type Grid3dInfo_api = {
    /**
     * Grid Name
     */
    grid_name: string;
    bbox: BoundingBox3d_api;
    dimensions: Grid3dDimensions_api;
    /**
     * Property Info Arr
     */
    property_info_arr: Array<Grid3dPropertyInfo_api>;
};

/**
 * Grid3dMappedProperty
 */
export type Grid3dMappedProperty_api = {
    poly_props_b64arr: B64FloatArray_api;
    /**
     * Min Grid Prop Value
     */
    min_grid_prop_value: number;
    /**
     * Max Grid Prop Value
     */
    max_grid_prop_value: number;
};

/**
 * Grid3dPropertyInfo
 *
 * Metadata for a 3D grid property
 */
export type Grid3dPropertyInfo_api = {
    /**
     * Property Name
     */
    property_name: string;
    /**
     * Iso Date Or Interval
     */
    iso_date_or_interval?: string | null;
};

/**
 * Grid3dZone
 *
 * Named subset of 3D grid layers (Zone)
 */
export type Grid3dZone_api = {
    /**
     * Name
     */
    name: string;
    /**
     * Start Layer
     */
    start_layer: number;
    /**
     * End Layer
     */
    end_layer: number;
};

/**
 * GridDimensions
 */
export type GridDimensions_api = {
    /**
     * I Count
     */
    i_count: number;
    /**
     * J Count
     */
    j_count: number;
    /**
     * K Count
     */
    k_count: number;
};

/**
 * HTTPValidationError
 */
export type HTTPValidationError_api = {
    /**
     * Detail
     */
    detail?: Array<ValidationError_api>;
};

/**
 * InitialFluidContactSurfaceMeta
 */
export type InitialFluidContactSurfaceMeta_api = {
    /**
     * Name
     */
    name: string;
    contact: InitialFluidContactType_api;
    standard_result: SurfaceStandardResult_api;
    /**
     * Name Is Stratigraphic Offical
     */
    name_is_stratigraphic_offical: boolean;
    /**
     * Value Min
     */
    value_min: number | null;
    /**
     * Value Max
     */
    value_max: number | null;
};

/**
 * InitialFluidContactType
 */
export enum InitialFluidContactType_api {
    FGL = "fgl",
    FWL = "fwl",
    GOC = "goc",
    GWC = "gwc",
    OWC = "owc",
}

/**
 * InplaceVolumesIndexWithValues
 *
 * Unique values for an index column in an inplace volumes table
 */
export type InplaceVolumesIndexWithValues_api = {
    /**
     * Indexcolumn
     */
    indexColumn: string;
    /**
     * Values
     */
    values: Array<string>;
};

/**
 * InplaceVolumesStatistic
 *
 * Definition of possible statistics for a result column in an inplace volumes table
 */
export enum InplaceVolumesStatistic_api {
    MEAN = "mean",
    STDDEV = "stddev",
    MAX = "max",
    MIN = "min",
    P10 = "p10",
    P90 = "p90",
}

/**
 * InplaceVolumesStatisticalTableData
 *
 * Statistical inplace volumes data for single volume table
 *
 * Contains data for a single fluid selection, e.g. Oil, Gas, Water, or sum of fluids
 */
export type InplaceVolumesStatisticalTableData_api = {
    /**
     * Fluidselection
     */
    fluidSelection: string;
    /**
     * Selectorcolumns
     */
    selectorColumns: Array<RepeatedTableColumnData_api>;
    /**
     * Resultcolumnstatistics
     */
    resultColumnStatistics: Array<TableColumnStatisticalData_api>;
};

/**
 * InplaceVolumesStatisticalTableDataPerFluidSelection
 *
 * Statistical inplace volumes data for a single table per fluid selection
 *
 * Fluid selection can be single fluid (Oil, Gas, Water) or sum of fluids (Oil + Gas + Water)
 */
export type InplaceVolumesStatisticalTableDataPerFluidSelection_api = {
    /**
     * Tabledataperfluidselection
     */
    tableDataPerFluidSelection: Array<InplaceVolumesStatisticalTableData_api>;
};

/**
 * InplaceVolumesTableData
 *
 * Inplace volumes data for a single table
 *
 * Contains data for a single fluid selection, e.g. Oil, Gas, Water, or sum of fluids
 */
export type InplaceVolumesTableData_api = {
    /**
     * Fluidselection
     */
    fluidSelection: string;
    /**
     * Selectorcolumns
     */
    selectorColumns: Array<RepeatedTableColumnData_api>;
    /**
     * Resultcolumns
     */
    resultColumns: Array<TableColumnData_api>;
};

/**
 * InplaceVolumesTableDataPerFluidSelection
 *
 * Inplace volumes data for a single table per fluid selection
 *
 * Fluid selection can be single fluid (Oil, Gas, Water) or sum of fluids (Oil + Gas + Water)
 */
export type InplaceVolumesTableDataPerFluidSelection_api = {
    /**
     * Tabledataperfluidselection
     */
    tableDataPerFluidSelection: Array<InplaceVolumesTableData_api>;
};

/**
 * InplaceVolumesTableDefinition
 *
 * Definition of a inplace volumes table
 */
export type InplaceVolumesTableDefinition_api = {
    /**
     * Tablename
     */
    tableName: string;
    /**
     * Resultnames
     */
    resultNames: Array<string>;
    /**
     * Indiceswithvalues
     */
    indicesWithValues: Array<InplaceVolumesIndexWithValues_api>;
};

/**
 * LroCommandResp
 */
export type LroCommandResp_api = {
    /**
     * Response Type
     */
    response_type: "LroCommandResp";
    /**
     * Command Ok
     */
    command_ok: boolean;
    /**
     * Message
     */
    message: string | null;
};

/**
 * LroFailureResp
 */
export type LroFailureResp_api = {
    /**
     * Response Type
     */
    response_type: "LroFailureResp";
    /**
     * Task Id
     */
    task_id: string | null;
    /**
     * Error Message
     */
    error_message: string | null;
};

/**
 * LroInProgressResp
 */
export type LroInProgressResp_api = {
    /**
     * Response Type
     */
    response_type: "LroInProgressResp";
    /**
     * Task Id
     */
    task_id: string;
    /**
     * Poll Url
     */
    poll_url: string | null;
    /**
     * Status Str
     */
    status_str: "pending" | "running" | string;
    /**
     * Progress Message
     */
    progress_message: string | null;
};

/**
 * LroSuccessResp[Union[SurfaceDataFloat, SurfaceDataPng]]
 */
export type LroSuccessRespUnionSurfaceDataFloatSurfaceDataPng_api = {
    /**
     * Response Type
     */
    response_type: "LroSuccessResp";
    /**
     * Result
     */
    result: SurfaceDataFloat_api | SurfaceDataPng_api;
};

/**
 * NetworkNode
 */
export type NetworkNode_api = {
    /**
     * Node Type
     */
    node_type: "Group" | "Well";
    /**
     * Node Label
     */
    node_label: string;
    /**
     * Edge Label
     */
    edge_label: string;
    /**
     * Node Data
     */
    node_data: {
        [key: string]: Array<number>;
    };
    /**
     * Edge Data
     */
    edge_data: {
        [key: string]: Array<number>;
    };
    /**
     * Children
     */
    children: Array<NetworkNode_api>;
};

/**
 * NewSession
 */
export type NewSession_api = {
    /**
     * Title
     */
    title: string;
    /**
     * Description
     */
    description: string | null;
    /**
     * Content
     */
    content: string;
};

/**
 * NewSnapshot
 */
export type NewSnapshot_api = {
    /**
     * Title
     */
    title: string;
    /**
     * Description
     */
    description: string | null;
    /**
     * Content
     */
    content: string;
};

/**
 * NodeType
 */
export enum NodeType_api {
    PROD = "prod",
    INJ = "inj",
    OTHER = "other",
}

/**
 * Page[SessionMetadata]
 */
export type PageSessionMetadata_api = {
    /**
     * Items
     */
    items: Array<SessionMetadata_api>;
    /**
     * Pagetoken
     */
    pageToken?: string | null;
};

/**
 * Page[SnapshotAccessLog]
 */
export type PageSnapshotAccessLog_api = {
    /**
     * Items
     */
    items: Array<SnapshotAccessLog_api>;
    /**
     * Pagetoken
     */
    pageToken?: string | null;
};

/**
 * Page[SnapshotMetadata]
 */
export type PageSnapshotMetadata_api = {
    /**
     * Items
     */
    items: Array<SnapshotMetadata_api>;
    /**
     * Pagetoken
     */
    pageToken?: string | null;
};

/**
 * PointSetXY
 */
export type PointSetXY_api = {
    /**
     * X Points
     */
    x_points: Array<number>;
    /**
     * Y Points
     */
    y_points: Array<number>;
};

/**
 * PolygonData
 */
export type PolygonData_api = {
    /**
     * X Arr
     */
    x_arr: Array<number>;
    /**
     * Y Arr
     */
    y_arr: Array<number>;
    /**
     * Z Arr
     */
    z_arr: Array<number>;
    /**
     * Poly Id
     */
    poly_id: number | string;
    /**
     * Name
     */
    name: string;
};

/**
 * PolygonsAttributeType
 *
 * To be revisited later when the metadata is more mature.
 */
export enum PolygonsAttributeType_api {
    DEPTH = "depth",
    TIME = "time",
    PROPERTY = "property",
    SEISMIC = "seismic",
    THICKNESS = "thickness",
    ISOCHORE = "isochore",
    FLUID_CONTACT = "fluid_contact",
    FIELD_OUTLINE = "field_outline",
    PINCHOUT = "pinchout",
    SUBCROP = "subcrop",
    FAULT_LINES = "fault_lines",
    NAMED_AREA = "named_area",
    REGIONS = "regions",
}

/**
 * PolygonsMeta
 */
export type PolygonsMeta_api = {
    /**
     * Name
     */
    name: string;
    /**
     * Name Is Stratigraphic Offical
     */
    name_is_stratigraphic_offical: boolean;
    /**
     * Stratigraphic Identifier
     */
    stratigraphic_identifier?: string | null;
    /**
     * Relative Stratigraphic Level
     */
    relative_stratigraphic_level?: number | null;
    /**
     * Parent Stratigraphic Identifier
     */
    parent_stratigraphic_identifier?: string | null;
    /**
     * Attribute Name
     */
    attribute_name: string;
    attribute_type: PolygonsAttributeType_api;
};

/**
 * PolylineIntersection
 */
export type PolylineIntersection_api = {
    /**
     * Fence Mesh Sections
     */
    fence_mesh_sections: Array<FenceMeshSection_api>;
    grid_dimensions: GridDimensions_api;
    /**
     * Min Grid Prop Value
     */
    min_grid_prop_value: number;
    /**
     * Max Grid Prop Value
     */
    max_grid_prop_value: number;
};

/**
 * PvtData
 */
export type PvtData_api = {
    /**
     * Name
     */
    name: string;
    /**
     * Phase
     */
    phase: string;
    /**
     * Pvtnum
     */
    pvtnum: number;
    /**
     * Ratio
     */
    ratio: Array<number>;
    /**
     * Pressure
     */
    pressure: Array<number>;
    /**
     * Volumefactor
     */
    volumefactor: Array<number>;
    /**
     * Viscosity
     */
    viscosity: Array<number>;
    /**
     * Density
     */
    density: Array<number>;
    /**
     * Pressure Unit
     */
    pressure_unit: string;
    /**
     * Volumefactor Unit
     */
    volumefactor_unit: string;
    /**
     * Viscosity Unit
     */
    viscosity_unit: string;
    /**
     * Density Unit
     */
    density_unit: string;
    /**
     * Ratio Unit
     */
    ratio_unit: string;
};

/**
 * RelpermCurveData
 */
export type RelpermCurveData_api = {
    /**
     * Curve Name
     */
    curve_name: string;
    /**
     * Curve Values
     */
    curve_values: Array<number>;
};

/**
 * RelpermRealizationData
 */
export type RelpermRealizationData_api = {
    /**
     * Realization
     */
    realization: number;
    /**
     * Satnum
     */
    satnum: number;
    /**
     * Curve Data
     */
    curve_data: Array<RelpermCurveData_api>;
};

/**
 * RelpermRealizationDataResponse
 */
export type RelpermRealizationDataResponse_api = {
    /**
     * Saturation Name
     */
    saturation_name: string;
    /**
     * Saturation Values By Satnum
     */
    saturation_values_by_satnum: Array<RelpermSaturationValues_api>;
    /**
     * Realization Data
     */
    realization_data: Array<RelpermRealizationData_api>;
};

/**
 * RelpermSaturationAxis
 */
export type RelpermSaturationAxis_api = {
    /**
     * Saturation Name
     */
    saturation_name: string;
    /**
     * Relperm Curve Names
     */
    relperm_curve_names: Array<string>;
    /**
     * Capillary Pressure Curve Names
     */
    capillary_pressure_curve_names: Array<string>;
};

/**
 * RelpermSaturationValues
 */
export type RelpermSaturationValues_api = {
    /**
     * Satnum
     */
    satnum: number;
    /**
     * Saturation Values
     */
    saturation_values: Array<number>;
};

/**
 * RelpermTableDefinition
 */
export type RelpermTableDefinition_api = {
    /**
     * Table Name
     */
    table_name: string;
    /**
     * Saturation Axes
     */
    saturation_axes: Array<RelpermSaturationAxis_api>;
    /**
     * Satnums
     */
    satnums: Array<number>;
    /**
     * Realizations
     */
    realizations: Array<number>;
};

/**
 * RepeatedTableColumnData
 *
 * Data for a single column in a volumetric table
 *
 * Length of index list should be equal to the number of rows in the table
 *
 * - unique_values: List of unique values in the column
 * - indices: List of indices, in unique_values list, for each row in the table
 */
export type RepeatedTableColumnData_api = {
    /**
     * Columnname
     */
    columnName: string;
    /**
     * Uniquevalues
     */
    uniqueValues: Array<string | number>;
    /**
     * Indices
     */
    indices: Array<number>;
};

/**
 * RftObservation
 */
export type RftObservation_api = {
    /**
     * Value
     */
    value: number;
    /**
     * Error
     */
    error: number;
    /**
     * Property
     */
    property: string;
    /**
     * East
     */
    east: number;
    /**
     * North
     */
    north: number;
    /**
     * Tvd
     */
    tvd: number;
    /**
     * Md
     */
    md?: number | null;
    /**
     * Zone
     */
    zone?: string | null;
};

/**
 * RftObservations
 */
export type RftObservations_api = {
    /**
     * Well Name
     */
    well_name: string;
    /**
     * Date
     */
    date: string;
    /**
     * Observations
     */
    observations: Array<RftObservation_api>;
};

/**
 * RftRealizationData
 */
export type RftRealizationData_api = {
    /**
     * Well Name
     */
    well_name: string;
    /**
     * Realization
     */
    realization: number;
    /**
     * Timestamp Utc Ms
     */
    timestamp_utc_ms: number;
    /**
     * Depth Arr
     */
    depth_arr: Array<number>;
    /**
     * Value Arr
     */
    value_arr: Array<number>;
};

/**
 * RftTableDefinition
 */
export type RftTableDefinition_api = {
    /**
     * Response Names
     */
    response_names: Array<string>;
    /**
     * Well Infos
     */
    well_infos: Array<RftWellInfo_api>;
};

/**
 * RftWellInfo
 */
export type RftWellInfo_api = {
    /**
     * Well Name
     */
    well_name: string;
    /**
     * Timestamps Utc Ms
     */
    timestamps_utc_ms: Array<number>;
};

/**
 * SeismicCubeMeta
 *
 * Metadata for a seismic cube.
 */
export type SeismicCubeMeta_api = {
    /**
     * Seismicattribute
     */
    seismicAttribute: string;
    /**
     * Unit
     */
    unit: string;
    /**
     * Isodateorinterval
     */
    isoDateOrInterval: string;
    representation: SeismicRepresentation_api;
    /**
     * Isdepth
     */
    isDepth: boolean;
    bbox: BoundingBox3d_api;
    spec: SeismicCubeSpec_api;
};

/**
 * SeismicCubeSpec
 *
 * Specification for a seismic cube.
 *
 * `Properties:`
 * - `numCols`: The number of columns in the seismic cube.
 * - `numRows`: The number of rows in the seismic cube.
 * - `numLayers`: The number of layers in the seismic cube.
 * - `xOrigin`: The x-coordinate of the origin of the cube [m].
 * - `yOrigin`: The y-coordinate of the origin of the cube [m].
 * - `zOrigin`: The z-coordinate of the origin of the cube [m].
 * - `xInc`: The increment in the x-direction [m].
 * - `yInc`: The increment in the y-direction [m].
 * - `zInc`: The increment in the z-direction [m].
 * - `yFlip`: {-1, 1} - The flip factor for the y-direction (1 if not flipped, -1 if flipped).
 * - `zFlip`: {-1, 1} - The flip factor for the z-direction (1 if not flipped, -1 if flipped).
 * - `rotationDeg`: The rotation angle of the cube [deg].
 */
export type SeismicCubeSpec_api = {
    /**
     * Numcols
     */
    numCols: number;
    /**
     * Numrows
     */
    numRows: number;
    /**
     * Numlayers
     */
    numLayers: number;
    /**
     * Xorigin
     */
    xOrigin: number;
    /**
     * Yorigin
     */
    yOrigin: number;
    /**
     * Zorigin
     */
    zOrigin: number;
    /**
     * Xinc
     */
    xInc: number;
    /**
     * Yinc
     */
    yInc: number;
    /**
     * Zinc
     */
    zInc: number;
    /**
     * Yflip
     */
    yFlip: number;
    /**
     * Zflip
     */
    zFlip: number;
    /**
     * Rotationdeg
     */
    rotationDeg: number;
};

/**
 * SeismicFenceData
 *
 * Definition of a fence of seismic data from a set of (x, y) coordinates in domain coordinate system.
 * Each (x, y) point provides a trace perpendicular to the x-y plane, with number of samples equal to the depth of the seismic cube.
 *
 * Each trace is defined to be a set of depth value samples along the length direction of the fence.
 *
 * `Properties:`
 * - `fence_traces_b64arr`: The fence trace array is base64 encoded 1D float array - where data is stored trace by trace.
 * - `num_traces`: The number of traces in the fence trace array. Equals the number of (x, y) coordinates in requested polyline.
 * - `num_samples_per_trace`: The number of samples in each trace.
 * - `min_fence_depth`: The minimum depth value of the fence.
 * - `max_fence_depth`: The maximum depth value of the fence.
 *
 * `Description - fence_traces_b64arr:`
 *
 * The encoded fence trace array is a flattened array of traces, where data is stored trace by trace.
 * With `m = num_traces`, and `n = num_samples_per_trace`, the flattened array has length `mxn`.
 *
 * Fence traces 1D array: [trace_1_sample_1, trace_1_sample_2, ..., trace_1_sample_n, ..., trace_m_sample_1, trace_m_sample_2, ..., trace_m_sample_n]
 *
 *
 * See:
 * - VdsAxis: https://github.com/equinor/vds-slice/blob/ab6f39789bf3d3b59a8df14f1c4682d340dc0bf3/internal/core/core.go#L37-L55
 */
export type SeismicFenceData_api = {
    fence_traces_b64arr: B64FloatArray_api;
    /**
     * Num Traces
     */
    num_traces: number;
    /**
     * Num Samples Per Trace
     */
    num_samples_per_trace: number;
    /**
     * Min Fence Depth
     */
    min_fence_depth: number;
    /**
     * Max Fence Depth
     */
    max_fence_depth: number;
};

/**
 * SeismicFencePolyline
 *
 * (x, y) points defining a polyline in domain coordinate system, to retrieve fence of seismic data.
 *
 * Expect equal number of x- and y-points.
 *
 * Note: Coordinates are in domain coordinate system (UTM).
 *
 * NOTE:
 * - Verify coordinates are in domain coordinate system (UTM)?
 * - Consider points_xy: List[float] - i.e. array with [x1, y1, x2, y2, ..., xn, yn] instead of x_points and y_points arrays?
 * - Ensure equal length of x_points and y_points arrays?
 */
export type SeismicFencePolyline_api = {
    /**
     * X Points
     */
    x_points: Array<number>;
    /**
     * Y Points
     */
    y_points: Array<number>;
};

/**
 * SeismicRepresentation
 */
export enum SeismicRepresentation_api {
    OBSERVED_CASE = "observed_case",
    OBSERVED_REALIZATION = "observed_realization",
    MODELLED = "modelled",
}

/**
 * SeismicSliceData
 *
 * Definition of a seismic slice from a seismic cube. This could be an inline, crossline, or depth slice.
 * u and v axes are the respective domain coordinate system axes, and the slice traces are the seismic data values.
 * The SeismicCubeMeta specification object (not part of this schema) provides a transformation matrix for converting
 * the slice data from its own coordinate system (u,v) to the global coordinate system.
 *
 * `Properties:`
 * - `slice_traces_b64arr`: The slice trace array is base64 encoded 1D float array - where data is stored trace by trace.
 * - `bbox_utm`: The bounding box of the slice in UTM coordinates.
 * - `u_min`: The minimum value of the u-axis.
 * - `u_max`: The maximum value of the u-axis.
 * - `u_num_samples`: The number of samples along the u-axis.
 * - `u_unit`: The unit of the u-axis.
 * - `v_min`: The minimum value of the v-axis.
 * - `v_max`: The maximum value of the v-axis.
 * - `v_num_samples`: The number of samples along the v-axis.
 * - `v_unit`: The unit of the v-axis.
 * - `value_min`: The minimum value of the seismic data values.
 * - `value_max`: The maximum value of the seismic data values.
 *
 * Fence traces 1D array: [trace_1_sample_1, trace_1_sample_2, ..., trace_1_sample_n, ..., trace_m_sample_1, trace_m_sample_2, ..., trace_m_sample_n]
 */
export type SeismicSliceData_api = {
    slice_traces_b64arr: B64FloatArray_api;
    /**
     * Bbox Utm
     */
    bbox_utm: Array<Array<number>>;
    /**
     * U Min
     */
    u_min: number;
    /**
     * U Max
     */
    u_max: number;
    /**
     * U Num Samples
     */
    u_num_samples: number;
    /**
     * U Unit
     */
    u_unit: string;
    /**
     * V Min
     */
    v_min: number;
    /**
     * V Max
     */
    v_max: number;
    /**
     * V Num Samples
     */
    v_num_samples: number;
    /**
     * V Unit
     */
    v_unit: string;
    /**
     * Value Min
     */
    value_min: number;
    /**
     * Value Max
     */
    value_max: number;
};

/**
 * SensitivityType
 */
export enum SensitivityType_api {
    MONTECARLO = "montecarlo",
    SCENARIO = "scenario",
}

/**
 * Session
 */
export type Session_api = {
    metadata: SessionMetadata_api;
    /**
     * Content
     */
    content: string;
};

/**
 * SessionMetadata
 */
export type SessionMetadata_api = {
    /**
     * Id
     */
    id: string;
    /**
     * Ownerid
     */
    ownerId: string;
    /**
     * Title
     */
    title: string;
    /**
     * Description
     */
    description: string | null;
    /**
     * Createdat
     */
    createdAt: string;
    /**
     * Updatedat
     */
    updatedAt: string;
    /**
     * Version
     */
    version: number;
    /**
     * Contenthash
     */
    contentHash: string;
};

/**
 * SessionSortBy
 */
export enum SessionSortBy_api {
    METADATA_CREATED_AT = "metadata.created_at",
    METADATA_UPDATED_AT = "metadata.updated_at",
    METADATA_TITLE = "metadata.title",
}

/**
 * SessionUpdate
 */
export type SessionUpdate_api = {
    /**
     * Title
     */
    title?: string | null;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Content
     */
    content?: string | null;
};

/**
 * Snapshot
 */
export type Snapshot_api = {
    metadata: SnapshotMetadata_api;
    /**
     * Content
     */
    content: string;
};

/**
 * SnapshotAccessLog
 */
export type SnapshotAccessLog_api = {
    /**
     * Visitorid
     */
    visitorId: string;
    /**
     * Snapshotid
     */
    snapshotId: string;
    /**
     * Visits
     */
    visits: number;
    /**
     * Firstvisitedat
     */
    firstVisitedAt: string | null;
    /**
     * Lastvisitedat
     */
    lastVisitedAt: string | null;
    /**
     * Snapshotdeleted
     */
    snapshotDeleted: boolean;
    snapshotMetadata: SnapshotMetadata_api;
};

/**
 * SnapshotAccessLogSortBy
 */
export enum SnapshotAccessLogSortBy_api {
    VISITS = "visits",
    LAST_VISITED_AT = "last_visited_at",
    SNAPSHOT_METADATA_TITLE = "snapshot_metadata.title",
    SNAPSHOT_METADATA_TITLE_LOWER = "snapshot_metadata.title__lower",
    SNAPSHOT_METADATA_CREATED_AT = "snapshot_metadata.created_at",
}

/**
 * SnapshotMetadata
 */
export type SnapshotMetadata_api = {
    /**
     * Id
     */
    id: string;
    /**
     * Ownerid
     */
    ownerId: string;
    /**
     * Title
     */
    title: string;
    /**
     * Description
     */
    description: string | null;
    /**
     * Createdat
     */
    createdAt: string;
    /**
     * Contenthash
     */
    contentHash: string;
};

/**
 * SnapshotSortBy
 */
export enum SnapshotSortBy_api {
    CREATED_AT = "created_at",
    UPDATED_AT = "updated_at",
    TITLE = "title",
    TITLE_LOWER = "title_lower",
}

/**
 * SortDirection
 */
export enum SortDirection_api {
    ASC = "asc",
    DESC = "desc",
}

/**
 * StatisticFunction
 */
export enum StatisticFunction_api {
    MEAN = "MEAN",
    MIN = "MIN",
    MAX = "MAX",
    P10 = "P10",
    P90 = "P90",
    P50 = "P50",
}

/**
 * StatisticValueObject
 */
export type StatisticValueObject_api = {
    statisticFunction: StatisticFunction_api;
    /**
     * Values
     */
    values: Array<number>;
};

/**
 * StdResAttribute
 *
 * Identifies a surface by the FMU standard result it belongs to.
 *
 * sub_name discriminates between surfaces within a standard result, e.g. the contact
 * type for fluid_contact_surface. It is None for standard results that do not need it.
 */
export type StdResAttribute_api = {
    /**
     * Kind
     */
    kind: "STDRES";
    std_res_name: SurfaceStandardResult_api;
    /**
     * Sub Name
     */
    sub_name?: string | null;
};

/**
 * StratigraphicColumn
 *
 * Stratigraphic column from SMDA
 */
export type StratigraphicColumn_api = {
    /**
     * Identifier
     */
    identifier: string;
    /**
     * Areatype
     */
    areaType: string;
    /**
     * Status
     */
    status: string;
    /**
     * Type
     */
    type: string | null;
};

/**
 * SummaryVectorDateObservation
 *
 * A single observation of a summary vector at a specific date.
 */
export type SummaryVectorDateObservation_api = {
    /**
     * Timestamp Utc Ms
     */
    timestamp_utc_ms: number;
    /**
     * Value
     */
    value: number;
    /**
     * Error
     */
    error: number;
    /**
     * Label
     */
    label: string;
};

/**
 * SummaryVectorObservations
 *
 * A collection of observations of a summary vector.
 */
export type SummaryVectorObservations_api = {
    /**
     * Vector Name
     */
    vector_name: string;
    /**
     * Observations
     */
    observations: Array<SummaryVectorDateObservation_api>;
};

/**
 * SurfaceAttributeType
 *
 * A surface has a single array with values, e.g. depth, time, property, seismic, thickness.
 * Only surfaces with depth and time have z-values that can be plotted in 3D.
 * The other attributes are scalar values that can be plotted in 2D or used as colormapping for 3D surfaces.
 *
 * Ideally if the attribute is a scalar, there should be corresponding z-values, but this information is not
 * available in the metadata.
 *
 * To be revisited later when the metadata is more mature.
 */
export enum SurfaceAttributeType_api {
    DEPTH = "depth",
    FACIES_THICKNESS = "facies_thickness",
    FLUID_CONTACT = "fluid_contact",
    PINCHOUT = "pinchout",
    PROPERTY = "property",
    SEISMIC = "seismic",
    SUBCROP = "subcrop",
    THICKNESS = "thickness",
    TIME = "time",
    VELOCITY = "velocity",
    VOLUMES = "volumes",
    UNKNOWN = "UNKNOWN",
}

/**
 * SurfaceDataFloat
 */
export type SurfaceDataFloat_api = {
    /**
     * Format
     */
    format?: "float";
    surface_def: SurfaceDef_api;
    transformed_bbox_utm: BoundingBox2d_api;
    /**
     * Value Min
     */
    value_min: number;
    /**
     * Value Max
     */
    value_max: number;
    values_b64arr: B64FloatArray_api;
};

/**
 * SurfaceDataPng
 */
export type SurfaceDataPng_api = {
    /**
     * Format
     */
    format?: "png";
    surface_def: SurfaceDef_api;
    transformed_bbox_utm: BoundingBox2d_api;
    /**
     * Value Min
     */
    value_min: number;
    /**
     * Value Max
     */
    value_max: number;
    /**
     * Png Image Base64
     */
    png_image_base64: string;
};

/**
 * SurfaceDef
 */
export type SurfaceDef_api = {
    /**
     * Npoints X
     */
    npoints_x: number;
    /**
     * Npoints Y
     */
    npoints_y: number;
    /**
     * Inc X
     */
    inc_x: number;
    /**
     * Inc Y
     */
    inc_y: number;
    /**
     * Origin Utm X
     */
    origin_utm_x: number;
    /**
     * Origin Utm Y
     */
    origin_utm_y: number;
    /**
     * Rot Deg
     */
    rot_deg: number;
};

/**
 * SurfaceIntersectionCumulativeLengthPolyline
 *
 * (x, y) points defining a polyline in domain coordinate system, to retrieve intersection of a surface, with a cumulative length
 * between at each (x, y)-point coordinates in domain coordinate system.
 *
 * Expect equal number of x- and y-points.
 *
 * x_points: X-coordinates of polyline points.
 * y_points: Y-coordinates of polyline points.
 * cum_lengths: Cumulative lengths of the polyline segments, i.e. the length of the polyline up to each (x,y) point.
 *
 * The cumulative lengths can be e.g. measured depth along a well path.
 *
 * Note: Coordinates are in domain coordinate system (UTM)
 *
 * Note: Verify if cum_lengths is necessary with respect to xtgeo
 */
export type SurfaceIntersectionCumulativeLengthPolyline_api = {
    /**
     * X Points
     */
    x_points: Array<number>;
    /**
     * Y Points
     */
    y_points: Array<number>;
    /**
     * Cum Lengths
     */
    cum_lengths: Array<number>;
};

/**
 * SurfaceIntersectionData
 *
 * Definition of a surface intersection made from a set of (x, y) coordinates.
 *
 * name: Name of the surface
 * z_points: Array of z-points (depth values) at the intersection points, i.e. depth value for each (x,y) point.
 * cum_lengths: Cumulative length values at the intersection points, i.e. accumulated length between each element in the z points.
 */
export type SurfaceIntersectionData_api = {
    /**
     * Name
     */
    name: string;
    /**
     * Z Points
     */
    z_points: Array<number>;
    /**
     * Cum Lengths
     */
    cum_lengths: Array<number>;
};

/**
 * SurfaceMeta
 */
export type SurfaceMeta_api = {
    /**
     * Name
     */
    name: string;
    /**
     * Name Is Stratigraphic Offical
     */
    name_is_stratigraphic_offical: boolean;
    /**
     * Attribute
     */
    attribute:
        | ({
              kind: "TAGNAME";
          } & TagNameAttribute_api)
        | ({
              kind: "STDRES";
          } & StdResAttribute_api);
    attribute_type: SurfaceAttributeType_api;
    time_type: SurfaceTimeType_api;
    /**
     * Is Observation
     */
    is_observation: boolean;
    /**
     * Value Min
     */
    value_min: number | null;
    /**
     * Value Max
     */
    value_max: number | null;
};

/**
 * SurfaceMetaSet
 */
export type SurfaceMetaSet_api = {
    /**
     * Surfaces
     */
    surfaces: Array<SurfaceMeta_api>;
    /**
     * Time Points Iso Str
     */
    time_points_iso_str: Array<string>;
    /**
     * Time Intervals Iso Str
     */
    time_intervals_iso_str: Array<string>;
    /**
     * Surface Names In Strat Order
     */
    surface_names_in_strat_order: Array<string>;
};

/**
 * SurfaceRealizationSampleValues
 */
export type SurfaceRealizationSampleValues_api = {
    /**
     * Realization
     */
    realization: number;
    /**
     * Sampled Values
     */
    sampled_values: Array<number>;
};

/**
 * SurfaceStandardResult
 *
 * The FMU standard results that are surfaces. Used when building standard result surface addresses.
 */
export enum SurfaceStandardResult_api {
    FLUID_CONTACT_SURFACE = "fluid_contact_surface",
    GRID_EXTRACTED_DEPTH_SURFACE = "grid_extracted_depth_surface",
    STRUCTURE_DEPTH_FAULT_SURFACE = "structure_depth_fault_surface",
    STRUCTURE_DEPTH_ISOCHORE = "structure_depth_isochore",
    STRUCTURE_DEPTH_SURFACE = "structure_depth_surface",
    STRUCTURE_TIME_SURFACE = "structure_time_surface",
}

/**
 * SurfaceStatisticFunction
 */
export enum SurfaceStatisticFunction_api {
    MEAN = "MEAN",
    STD = "STD",
    MIN = "MIN",
    MAX = "MAX",
    P10 = "P10",
    P90 = "P90",
    P50 = "P50",
}

/**
 * SurfaceTimeType
 */
export enum SurfaceTimeType_api {
    NO_TIME = "NO_TIME",
    TIME_POINT = "TIME_POINT",
    INTERVAL = "INTERVAL",
}

/**
 * THP
 */
export enum THP_api {
    THP = "THP",
}

/**
 * TabType
 */
export enum TabType_api {
    BHP = "BHP",
    TEMP = "TEMP",
}

/**
 * TableColumnData
 *
 * Data for a single column in a volumetric table
 *
 * Length of column values should be equal to the number of rows in the table
 */
export type TableColumnData_api = {
    /**
     * Columnname
     */
    columnName: string;
    /**
     * Columnvalues
     */
    columnValues: Array<number>;
};

/**
 * TableColumnStatisticalData
 *
 * Statistical data for a single result column in a volumetric table
 *
 * Length of column values should be equal to the number of rows in the table
 */
export type TableColumnStatisticalData_api = {
    /**
     * Columnname
     */
    columnName: string;
    /**
     * Statisticvalues
     */
    statisticValues: {
        [key in InplaceVolumesStatistic_api]?: Array<number>;
    };
};

/**
 * TagNameAttribute
 *
 * Identifies a surface by the free text tagname it was exported with.
 */
export type TagNameAttribute_api = {
    /**
     * Kind
     */
    kind: "TAGNAME";
    /**
     * Tag Name
     */
    tag_name: string;
};

/**
 * TutorialMediaSasToken
 */
export type TutorialMediaSasToken_api = {
    /**
     * Sastoken
     */
    sasToken: string;
};

/**
 * UnitType
 */
export enum UnitType_api {
    METRIC = "METRIC",
    FIELD = "FIELD",
    LAB = "LAB",
    PVT_M = "PVT-M",
    DEFAULT = "DEFAULT",
}

/**
 * UserInfo
 */
export type UserInfo_api = {
    /**
     * User Id
     */
    user_id: string;
    /**
     * Username
     */
    username: string;
    /**
     * Display Name
     */
    display_name?: string | null;
    /**
     * Avatar B64Str
     */
    avatar_b64str?: string | null;
    /**
     * Has Sumo Access
     */
    has_sumo_access: boolean;
    /**
     * Has Smda Access
     */
    has_smda_access: boolean;
};

/**
 * ValidationError
 */
export type ValidationError_api = {
    /**
     * Location
     */
    loc: Array<string | number>;
    /**
     * Message
     */
    msg: string;
    /**
     * Error Type
     */
    type: string;
    /**
     * Input
     */
    input?: unknown;
    /**
     * Context
     */
    ctx?: {
        [key: string]: unknown;
    };
};

/**
 * VectorDescription
 */
export type VectorDescription_api = {
    /**
     * Name
     */
    name: string;
    /**
     * Descriptivename
     */
    descriptiveName: string;
    /**
     * Hashistorical
     */
    hasHistorical: boolean;
    derivedVectorInfo?: DerivedVectorInfo_api | null;
};

/**
 * VectorHistoricalData
 */
export type VectorHistoricalData_api = {
    /**
     * Timestampsutcms
     */
    timestampsUtcMs: Array<number>;
    /**
     * Values
     */
    values: Array<number>;
    /**
     * Unit
     */
    unit: string;
    /**
     * Israte
     */
    isRate: boolean;
};

/**
 * VectorRealizationData
 */
export type VectorRealizationData_api = {
    /**
     * Realization
     */
    realization: number;
    /**
     * Timestampsutcms
     */
    timestampsUtcMs: Array<number>;
    /**
     * Values
     */
    values: Array<number>;
    /**
     * Unit
     */
    unit: string;
    /**
     * Israte
     */
    isRate: boolean;
    derivedVectorInfo?: DerivedVectorInfo_api | null;
};

/**
 * VectorStatisticData
 */
export type VectorStatisticData_api = {
    /**
     * Realizations
     */
    realizations: Array<number>;
    /**
     * Timestampsutcms
     */
    timestampsUtcMs: Array<number>;
    /**
     * Valueobjects
     */
    valueObjects: Array<StatisticValueObject_api>;
    /**
     * Unit
     */
    unit: string;
    /**
     * Israte
     */
    isRate: boolean;
    derivedVectorInfo?: DerivedVectorInfo_api | null;
};

/**
 * VectorStatisticSensitivityData
 */
export type VectorStatisticSensitivityData_api = {
    /**
     * Realizations
     */
    realizations: Array<number>;
    /**
     * Timestampsutcms
     */
    timestampsUtcMs: Array<number>;
    /**
     * Valueobjects
     */
    valueObjects: Array<StatisticValueObject_api>;
    /**
     * Unit
     */
    unit: string;
    /**
     * Israte
     */
    isRate: boolean;
    /**
     * Sensitivityname
     */
    sensitivityName: string;
    /**
     * Sensitivitycase
     */
    sensitivityCase: string;
};

/**
 * VfpInjTable
 */
export type VfpInjTable_api = {
    /**
     * Vfptype
     */
    vfpType?: "INJ";
    /**
     * Tablenumber
     */
    tableNumber: number;
    /**
     * Datum
     */
    datum: number;
    flowRateType: FlowRateType_api;
    unitType: UnitType_api;
    tabType: TabType_api;
    /**
     * Thpvalues
     */
    thpValues: Array<number>;
    /**
     * Flowratevalues
     */
    flowRateValues: Array<number>;
    /**
     * Bhpvalues
     */
    bhpValues: Array<number>;
    /**
     * Flowrateunit
     */
    flowRateUnit: string;
    /**
     * Thpunit
     */
    thpUnit: string;
    /**
     * Bhpunit
     */
    bhpUnit: string;
};

/**
 * VfpProdTable
 */
export type VfpProdTable_api = {
    /**
     * Vfptype
     */
    vfpType?: "PROD";
    /**
     * Tablenumber
     */
    tableNumber: number;
    /**
     * Datum
     */
    datum: number;
    flowRateType: FlowRateType_api;
    unitType: UnitType_api;
    tabType: TabType_api;
    /**
     * Thpvalues
     */
    thpValues: Array<number>;
    /**
     * Flowratevalues
     */
    flowRateValues: Array<number>;
    /**
     * Bhpvalues
     */
    bhpValues: Array<number>;
    /**
     * Flowrateunit
     */
    flowRateUnit: string;
    /**
     * Thpunit
     */
    thpUnit: string;
    /**
     * Bhpunit
     */
    bhpUnit: string;
    thpType: THP_api;
    wfrType: WFR_api;
    gfrType: GFR_api;
    alqType: ALQ_api;
    /**
     * Wfrvalues
     */
    wfrValues: Array<number>;
    /**
     * Gfrvalues
     */
    gfrValues: Array<number>;
    /**
     * Alqvalues
     */
    alqValues: Array<number>;
    /**
     * Wfrunit
     */
    wfrUnit: string;
    /**
     * Gfrunit
     */
    gfrUnit: string;
    /**
     * Alqunit
     */
    alqUnit: string;
};

/**
 * VfpTableInfo
 */
export type VfpTableInfo_api = {
    /**
     * Vfptype
     */
    vfpType: "INJ" | "PROD";
    /**
     * Tablenumber
     */
    tableNumber: number;
};

/**
 * VfpType
 */
export enum VfpType_api {
    PROD = "PROD",
    INJ = "INJ",
}

/**
 * WFR
 */
export enum WFR_api {
    WOR = "WOR",
    WCT = "WCT",
    WGR = "WGR",
    WWR = "WWR",
    WTF = "WTF",
}

/**
 * WellCompletionsData
 *
 * Type definition for well completions data
 */
export type WellCompletionsData_api = {
    /**
     * Version
     */
    version: string;
    units: WellCompletionsUnits_api;
    /**
     * Zones
     */
    zones: Array<WellCompletionsZone_api>;
    /**
     * Sortedcompletiondates
     */
    sortedCompletionDates: Array<string>;
    /**
     * Wells
     */
    wells: Array<WellCompletionsWell_api>;
};

/**
 * WellCompletionsUnitInfo
 */
export type WellCompletionsUnitInfo_api = {
    /**
     * Unit
     */
    unit: string;
    /**
     * Decimalplaces
     */
    decimalPlaces: number;
};

/**
 * WellCompletionsUnits
 */
export type WellCompletionsUnits_api = {
    kh: WellCompletionsUnitInfo_api;
};

/**
 * WellCompletionsWell
 */
export type WellCompletionsWell_api = {
    /**
     * Name
     */
    name: string;
    /**
     * Attributes
     */
    attributes: {
        [key: string]: string | number | boolean;
    };
    /**
     * Completions
     */
    completions: {
        [key: string]: Completions_api;
    };
};

/**
 * WellCompletionsZone
 */
export type WellCompletionsZone_api = {
    /**
     * Name
     */
    name: string;
    /**
     * Subzones
     */
    subzones?: Array<WellCompletionsZone_api> | null;
};

/**
 * WellInjectionData
 */
export type WellInjectionData_api = {
    /**
     * Wellboreuuid
     */
    wellboreUuid: string;
    /**
     * Wellboreuwi
     */
    wellboreUwi: string;
    /**
     * Startdate
     */
    startDate: string;
    /**
     * Enddate
     */
    endDate: string;
    /**
     * Waterinjection
     */
    waterInjection: number;
    /**
     * Gasinjection
     */
    gasInjection: number;
};

/**
 * WellLogCurveSourceEnum
 */
export enum WellLogCurveSourceEnum_api {
    SSDL_WELL_LOG = "ssdl.well_log",
    SMDA_GEOLOGY = "smda.geology",
    SMDA_STRATIGRAPHY = "smda.stratigraphy",
    SMDA_SURVEY = "smda.survey",
}

/**
 * WellLogCurveTypeEnum
 */
export enum WellLogCurveTypeEnum_api {
    CONTINUOUS = "continuous",
    DISCRETE = "discrete",
    FLAG = "flag",
}

/**
 * WellProductionData
 */
export type WellProductionData_api = {
    /**
     * Wellboreuuid
     */
    wellboreUuid: string;
    /**
     * Wellboreuwi
     */
    wellboreUwi: string;
    /**
     * Startdate
     */
    startDate: string;
    /**
     * Enddate
     */
    endDate: string;
    /**
     * Oilproductionsm3
     */
    oilProductionSm3: number;
    /**
     * Gasproductionsm3
     */
    gasProductionSm3: number;
    /**
     * Waterproductionm3
     */
    waterProductionM3: number;
};

/**
 * WellTrajectory
 *
 * Well trajectory defined by a set of (x, y, z) coordinates and measured depths (md).
 *
 * uwi: Unique wellbore identifier.
 * xPoints: X-coordinates of well trajectory points.
 * yPoints: Y-coordinates of well trajectory points.
 * zPoints: Z-coordinates (depth values) of well trajectory points.
 * mdPoints: Measured depth values at each well trajectory point.
 */
export type WellTrajectory_api = {
    /**
     * Xpoints
     */
    xPoints: Array<number>;
    /**
     * Ypoints
     */
    yPoints: Array<number>;
    /**
     * Zpoints
     */
    zPoints: Array<number>;
    /**
     * Mdpoints
     */
    mdPoints: Array<number>;
    /**
     * Uwi
     */
    uwi: string;
};

export type WellTrajectoryFormationSegments_api =
    | ({
          status: "success";
      } & WellTrajectoryFormationSegmentsSuccess_api)
    | ({
          status: "error";
      } & WellTrajectoryFormationSegmentsError_api);

/**
 * WellTrajectoryFormationSegmentsError
 *
 * Error response when retrieving well trajectory formation segments.
 *
 * status: "error"
 * uwi: str
 * errorMessage: str
 */
export type WellTrajectoryFormationSegmentsError_api = {
    /**
     * Status
     */
    status?: "error";
    /**
     * Uwi
     */
    uwi: string;
    /**
     * Errormessage
     */
    errorMessage: string;
};

/**
 * WellTrajectoryFormationSegmentsSuccess
 *
 * Segments of a well trajectory that intersects a formation defined by top and bottom surfaces.
 *
 * A wellbore can enter and exit a formation multiple times, resulting in multiple segments.
 *
 * status: "success"
 * uwi: str
 * formationSegments: list[FormationSegment]
 */
export type WellTrajectoryFormationSegmentsSuccess_api = {
    /**
     * Status
     */
    status?: "success";
    /**
     * Uwi
     */
    uwi: string;
    /**
     * Formationsegments
     */
    formationSegments: Array<FormationSegment_api>;
};

/**
 * WellboreCasing
 *
 * Single casing for a wellbore
 */
export type WellboreCasing_api = {
    /**
     * Itemtype
     */
    itemType: string;
    /**
     * Diameternumeric
     */
    diameterNumeric: number;
    /**
     * Diameterinner
     */
    diameterInner: number;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Remark
     */
    remark?: string | null;
    /**
     * Depthtopmd
     */
    depthTopMd: number;
    /**
     * Depthbottommd
     */
    depthBottomMd: number;
    /**
     * Totaldepthmd
     */
    totalDepthMd: number;
    /**
     * Startdepth
     */
    startDepth: number;
    /**
     * Enddepth
     */
    endDepth: number;
};

/**
 * WellboreCompletion
 *
 * Single completion for a wellbore
 */
export type WellboreCompletion_api = {
    /**
     * Mdtop
     */
    mdTop: number;
    /**
     * Mdbottom
     */
    mdBottom: number;
    /**
     * Tvdtop
     */
    tvdTop: number | null;
    /**
     * Tvdbottom
     */
    tvdBottom: number | null;
    /**
     * Description
     */
    description: string | null;
    /**
     * Symbolname
     */
    symbolName: string | null;
    /**
     * Comment
     */
    comment: string | null;
};

/**
 * WellboreCompletions
 *
 * Completions for a wellbore
 */
export type WellboreCompletions_api = {
    /**
     * Wellboreuuid
     */
    wellboreUuid: string;
    /**
     * Completions
     */
    completions: Array<WellboreCompletion_api>;
};

/**
 * WellboreHeader
 */
export type WellboreHeader_api = {
    /**
     * Wellboreuuid
     */
    wellboreUuid: string;
    /**
     * Uniquewellboreidentifier
     */
    uniqueWellboreIdentifier: string;
    /**
     * Welluuid
     */
    wellUuid: string;
    /**
     * Uniquewellidentifier
     */
    uniqueWellIdentifier: string;
    /**
     * Welleasting
     */
    wellEasting: number;
    /**
     * Wellnorthing
     */
    wellNorthing: number;
    /**
     * Depthreferencepoint
     */
    depthReferencePoint: string;
    /**
     * Depthreferenceelevation
     */
    depthReferenceElevation: number;
    /**
     * Wellborepurpose
     */
    wellborePurpose: string;
    /**
     * Wellborestatus
     */
    wellboreStatus: string;
    /**
     * Kickoffdepthmd
     */
    kickoffDepthMd: number | null;
    /**
     * Kickoffdepthtvd
     */
    kickoffDepthTvd: number | null;
    /**
     * Parentwellbore
     */
    parentWellbore: string | null;
    /**
     * Mdmin
     */
    mdMin?: number | null;
    /**
     * Mdmax
     */
    mdMax?: number | null;
    /**
     * Mdunit
     */
    mdUnit?: string | null;
    /**
     * Tvdmin
     */
    tvdMin?: number | null;
    /**
     * Tvdmax
     */
    tvdMax?: number | null;
    /**
     * Tvdunit
     */
    tvdUnit?: string | null;
};

/**
 * WellboreLogCurveData
 */
export type WellboreLogCurveData_api = {
    source: WellLogCurveSourceEnum_api;
    /**
     * Name
     */
    name: string;
    /**
     * Logname
     */
    logName: string;
    /**
     * Indexmin
     */
    indexMin: number;
    /**
     * Indexmax
     */
    indexMax: number;
    /**
     * Mincurvevalue
     */
    minCurveValue: number | null;
    /**
     * Maxcurvevalue
     */
    maxCurveValue: number | null;
    /**
     * Curvealias
     */
    curveAlias: string | null;
    /**
     * Curvedescription
     */
    curveDescription: string | null;
    /**
     * Indexunit
     */
    indexUnit: string;
    /**
     * Nodatavalue
     */
    noDataValue: number | null;
    /**
     * Unit
     */
    unit: string | null;
    /**
     * Curveunitdesc
     */
    curveUnitDesc: string | null;
    /**
     * Datapoints
     */
    dataPoints: Array<[number, number | string | null]>;
    /**
     * Discretevaluemetadata
     */
    discreteValueMetadata: Array<DiscreteValueMetadata_api> | null;
};

/**
 * WellboreLogCurveHeader
 */
export type WellboreLogCurveHeader_api = {
    source: WellLogCurveSourceEnum_api;
    curveType: WellLogCurveTypeEnum_api;
    /**
     * Logname
     */
    logName: string;
    /**
     * Curvename
     */
    curveName: string;
    /**
     * Curveunit
     */
    curveUnit: string | null;
};

/**
 * WellborePerforation
 *
 * Single perforation for a wellbore
 */
export type WellborePerforation_api = {
    /**
     * Mdtop
     */
    mdTop: number;
    /**
     * Mdbottom
     */
    mdBottom: number;
    /**
     * Tvdtop
     */
    tvdTop: number;
    /**
     * Tvdbottom
     */
    tvdBottom: number;
    /**
     * Status
     */
    status: string;
    /**
     * Completionmode
     */
    completionMode: string;
    /**
     * Dateshot
     */
    dateShot: string | null;
    /**
     * Dateclosed
     */
    dateClosed: string | null;
};

/**
 * WellborePerforations
 *
 * Perforations for a wellbore
 */
export type WellborePerforations_api = {
    /**
     * Wellboreuuid
     */
    wellboreUuid: string;
    /**
     * Perforations
     */
    perforations: Array<WellborePerforation_api>;
};

/**
 * WellborePick
 *
 * Wellbore pick from SMDA
 *
 * Camel case attributes needed for esvIntersection component in front-end
 */
export type WellborePick_api = {
    /**
     * Northing
     */
    northing: number;
    /**
     * Easting
     */
    easting: number;
    /**
     * Tvd
     */
    tvd: number;
    /**
     * Tvdmsl
     */
    tvdMsl: number;
    /**
     * Md
     */
    md: number;
    /**
     * Mdmsl
     */
    mdMsl: number;
    /**
     * Uniquewellboreidentifier
     */
    uniqueWellboreIdentifier: string;
    /**
     * Wellboreuuid
     */
    wellboreUuid: string;
    /**
     * Pickidentifier
     */
    pickIdentifier: string;
    /**
     * Confidence
     */
    confidence?: string | null;
    /**
     * Depthreferencepoint
     */
    depthReferencePoint: string;
    /**
     * Mdunit
     */
    mdUnit: string;
    /**
     * Interpreter
     */
    interpreter: string | null;
    /**
     * Obsno
     */
    obsNo: number;
};

/**
 * WellboreTrajectory
 */
export type WellboreTrajectory_api = {
    /**
     * Wellboreuuid
     */
    wellboreUuid: string;
    /**
     * Uniquewellboreidentifier
     */
    uniqueWellboreIdentifier: string;
    /**
     * Tvdmslarr
     */
    tvdMslArr: Array<number>;
    /**
     * Mdarr
     */
    mdArr: Array<number>;
    /**
     * Eastingarr
     */
    eastingArr: Array<number>;
    /**
     * Northingarr
     */
    northingArr: Array<number>;
};

export type GetAssetInfosData_api = {
    body?: never;
    path?: never;
    query?: {
        zCacheBust?: string;
    };
    url: "/asset_infos";
};

export type GetAssetInfosResponses_api = {
    /**
     * Response Get Asset Infos
     *
     * Successful Response
     */
    200: Array<AssetInfo_api>;
};

export type GetAssetInfosResponse_api = GetAssetInfosResponses_api[keyof GetAssetInfosResponses_api];

export type GetFieldIdentifiersData_api = {
    body?: never;
    path?: never;
    query?: {
        zCacheBust?: string;
    };
    url: "/field_identifiers";
};

export type GetFieldIdentifiersResponses_api = {
    /**
     * Response Get Field Identifiers
     *
     * Successful Response
     */
    200: Array<FieldInfo_api>;
};

export type GetFieldIdentifiersResponse_api = GetFieldIdentifiersResponses_api[keyof GetFieldIdentifiersResponses_api];

export type GetCasesData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Asset Name
         *
         * Asset name
         */
        asset_name: string;
        zCacheBust?: string;
    };
    url: "/cases";
};

export type GetCasesErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetCasesError_api = GetCasesErrors_api[keyof GetCasesErrors_api];

export type GetCasesResponses_api = {
    /**
     * Response Get Cases
     *
     * Successful Response
     */
    200: Array<CaseInfo_api>;
};

export type GetCasesResponse_api = GetCasesResponses_api[keyof GetCasesResponses_api];

export type GetEnsembleDetailsData_api = {
    body?: never;
    path: {
        /**
         * Case Uuid
         *
         * Sumo case uuid
         */
        case_uuid: string;
        /**
         * Ensemble Name
         *
         * Ensemble name
         */
        ensemble_name: string;
    };
    query?: {
        zCacheBust?: string;
    };
    url: "/cases/{case_uuid}/ensembles/{ensemble_name}";
};

export type GetEnsembleDetailsErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetEnsembleDetailsError_api = GetEnsembleDetailsErrors_api[keyof GetEnsembleDetailsErrors_api];

export type GetEnsembleDetailsResponses_api = {
    /**
     * Successful Response
     */
    200: EnsembleDetails_api;
};

export type GetEnsembleDetailsResponse_api = GetEnsembleDetailsResponses_api[keyof GetEnsembleDetailsResponses_api];

export type PostRefreshFingerprintsForEnsemblesData_api = {
    /**
     * Ensemble Idents
     *
     * Ensembles to refresh and get fingerprints for, specified as pairs of caseUuid,ensembleName
     */
    body: Array<EnsembleIdent_api>;
    path?: never;
    query?: {
        zCacheBust?: string;
    };
    url: "/ensembles/refresh_fingerprints";
};

export type PostRefreshFingerprintsForEnsemblesErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type PostRefreshFingerprintsForEnsemblesError_api =
    PostRefreshFingerprintsForEnsemblesErrors_api[keyof PostRefreshFingerprintsForEnsemblesErrors_api];

export type PostRefreshFingerprintsForEnsemblesResponses_api = {
    /**
     * Response Post Refresh Fingerprints For Ensembles
     *
     * Successful Response
     */
    200: Array<string | null>;
};

export type PostRefreshFingerprintsForEnsemblesResponse_api =
    PostRefreshFingerprintsForEnsemblesResponses_api[keyof PostRefreshFingerprintsForEnsemblesResponses_api];

export type GetVectorListData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Case Uuid
         *
         * Sumo case uuid
         */
        case_uuid: string;
        /**
         * Ensemble Name
         *
         * Ensemble name
         */
        ensemble_name: string;
        /**
         * Include Derived Vectors
         *
         * Include derived vectors
         */
        include_derived_vectors?: boolean | null;
        zCacheBust?: string;
    };
    url: "/timeseries/vector_list/";
};

export type GetVectorListErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetVectorListError_api = GetVectorListErrors_api[keyof GetVectorListErrors_api];

export type GetVectorListResponses_api = {
    /**
     * Response Get Vector List
     *
     * Successful Response
     */
    200: Array<VectorDescription_api>;
};

export type GetVectorListResponse_api = GetVectorListResponses_api[keyof GetVectorListResponses_api];

export type GetDeltaEnsembleVectorListData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Comparison Case Uuid
         *
         * Sumo case uuid for comparison ensemble
         */
        comparison_case_uuid: string;
        /**
         * Comparison Ensemble Name
         *
         * Comparison ensemble name
         */
        comparison_ensemble_name: string;
        /**
         * Reference Case Uuid
         *
         * Sumo case uuid for reference ensemble
         */
        reference_case_uuid: string;
        /**
         * Reference Ensemble Name
         *
         * Reference ensemble name
         */
        reference_ensemble_name: string;
        /**
         * Include Derived Vectors
         *
         * Include derived vectors
         */
        include_derived_vectors?: boolean | null;
        zCacheBust?: string;
    };
    url: "/timeseries/delta_ensemble_vector_list/";
};

export type GetDeltaEnsembleVectorListErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetDeltaEnsembleVectorListError_api =
    GetDeltaEnsembleVectorListErrors_api[keyof GetDeltaEnsembleVectorListErrors_api];

export type GetDeltaEnsembleVectorListResponses_api = {
    /**
     * Response Get Delta Ensemble Vector List
     *
     * Successful Response
     */
    200: Array<VectorDescription_api>;
};

export type GetDeltaEnsembleVectorListResponse_api =
    GetDeltaEnsembleVectorListResponses_api[keyof GetDeltaEnsembleVectorListResponses_api];

export type GetRealizationsVectorDataData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Case Uuid
         *
         * Sumo case uuid
         */
        case_uuid: string;
        /**
         * Ensemble Name
         *
         * Ensemble name
         */
        ensemble_name: string;
        /**
         * Vector Name
         *
         * Name of the vector
         */
        vector_name: string;
        /**
         * Resampling Frequency
         *
         * Resampling frequency. If not specified, raw data without resampling wil be returned.
         */
        resampling_frequency?: Frequency_api | null;
        /**
         * Realizations Encoded As Uint List Str
         *
         * Optional list of realizations encoded as string to include. If not specified, all realizations will be included.
         */
        realizations_encoded_as_uint_list_str?: string | null;
        zCacheBust?: string;
    };
    url: "/timeseries/realizations_vector_data/";
};

export type GetRealizationsVectorDataErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetRealizationsVectorDataError_api =
    GetRealizationsVectorDataErrors_api[keyof GetRealizationsVectorDataErrors_api];

export type GetRealizationsVectorDataResponses_api = {
    /**
     * Response Get Realizations Vector Data
     *
     * Successful Response
     */
    200: Array<VectorRealizationData_api>;
};

export type GetRealizationsVectorDataResponse_api =
    GetRealizationsVectorDataResponses_api[keyof GetRealizationsVectorDataResponses_api];

export type GetDeltaEnsembleRealizationsVectorDataData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Comparison Case Uuid
         *
         * Sumo case uuid for comparison ensemble
         */
        comparison_case_uuid: string;
        /**
         * Comparison Ensemble Name
         *
         * Comparison ensemble name
         */
        comparison_ensemble_name: string;
        /**
         * Reference Case Uuid
         *
         * Sumo case uuid for reference ensemble
         */
        reference_case_uuid: string;
        /**
         * Reference Ensemble Name
         *
         * Reference ensemble name
         */
        reference_ensemble_name: string;
        /**
         * Vector Name
         *
         * Name of the vector
         */
        vector_name: string;
        /**
         * Resampling frequency
         */
        resampling_frequency: Frequency_api;
        /**
         * Realizations Encoded As Uint List Str
         *
         * Optional list of realizations encoded as string to include. If not specified, all realizations will be included.
         */
        realizations_encoded_as_uint_list_str?: string | null;
        zCacheBust?: string;
    };
    url: "/timeseries/delta_ensemble_realizations_vector_data/";
};

export type GetDeltaEnsembleRealizationsVectorDataErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetDeltaEnsembleRealizationsVectorDataError_api =
    GetDeltaEnsembleRealizationsVectorDataErrors_api[keyof GetDeltaEnsembleRealizationsVectorDataErrors_api];

export type GetDeltaEnsembleRealizationsVectorDataResponses_api = {
    /**
     * Response Get Delta Ensemble Realizations Vector Data
     *
     * Successful Response
     */
    200: Array<VectorRealizationData_api>;
};

export type GetDeltaEnsembleRealizationsVectorDataResponse_api =
    GetDeltaEnsembleRealizationsVectorDataResponses_api[keyof GetDeltaEnsembleRealizationsVectorDataResponses_api];

export type GetHistoricalVectorDataData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Case Uuid
         *
         * Sumo case uuid
         */
        case_uuid: string;
        /**
         * Ensemble Name
         *
         * Ensemble name
         */
        ensemble_name: string;
        /**
         * Non Historical Vector Name
         *
         * Name of the non-historical vector
         */
        non_historical_vector_name: string;
        /**
         * Resampling Frequency
         *
         * Resampling frequency
         */
        resampling_frequency?: Frequency_api | null;
        zCacheBust?: string;
    };
    url: "/timeseries/historical_vector_data/";
};

export type GetHistoricalVectorDataErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetHistoricalVectorDataError_api =
    GetHistoricalVectorDataErrors_api[keyof GetHistoricalVectorDataErrors_api];

export type GetHistoricalVectorDataResponses_api = {
    /**
     * Successful Response
     */
    200: VectorHistoricalData_api;
};

export type GetHistoricalVectorDataResponse_api =
    GetHistoricalVectorDataResponses_api[keyof GetHistoricalVectorDataResponses_api];

export type GetStatisticalVectorDataData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Case Uuid
         *
         * Sumo case uuid
         */
        case_uuid: string;
        /**
         * Ensemble Name
         *
         * Ensemble name
         */
        ensemble_name: string;
        /**
         * Vector Name
         *
         * Name of the vector
         */
        vector_name: string;
        /**
         * Resampling frequency
         */
        resampling_frequency: Frequency_api;
        /**
         * Statistic Functions
         *
         * Optional list of statistics to calculate. If not specified, all statistics will be calculated.
         */
        statistic_functions?: Array<StatisticFunction_api> | null;
        /**
         * Realizations Encoded As Uint List Str
         *
         * Optional list of realizations encoded as string to include. If not specified, all realizations will be included.
         */
        realizations_encoded_as_uint_list_str?: string | null;
        zCacheBust?: string;
    };
    url: "/timeseries/statistical_vector_data/";
};

export type GetStatisticalVectorDataErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetStatisticalVectorDataError_api =
    GetStatisticalVectorDataErrors_api[keyof GetStatisticalVectorDataErrors_api];

export type GetStatisticalVectorDataResponses_api = {
    /**
     * Successful Response
     */
    200: VectorStatisticData_api;
};

export type GetStatisticalVectorDataResponse_api =
    GetStatisticalVectorDataResponses_api[keyof GetStatisticalVectorDataResponses_api];

export type GetDeltaEnsembleStatisticalVectorDataData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Comparison Case Uuid
         *
         * Sumo case uuid for comparison ensemble
         */
        comparison_case_uuid: string;
        /**
         * Comparison Ensemble Name
         *
         * Comparison ensemble name
         */
        comparison_ensemble_name: string;
        /**
         * Reference Case Uuid
         *
         * Sumo case uuid for reference ensemble
         */
        reference_case_uuid: string;
        /**
         * Reference Ensemble Name
         *
         * Reference ensemble name
         */
        reference_ensemble_name: string;
        /**
         * Vector Name
         *
         * Name of the vector
         */
        vector_name: string;
        /**
         * Resampling frequency
         */
        resampling_frequency: Frequency_api;
        /**
         * Statistic Functions
         *
         * Optional list of statistics to calculate. If not specified, all statistics will be calculated.
         */
        statistic_functions?: Array<StatisticFunction_api> | null;
        /**
         * Realizations Encoded As Uint List Str
         *
         * Optional list of realizations encoded as string to include. If not specified, all realizations will be included.
         */
        realizations_encoded_as_uint_list_str?: string | null;
        zCacheBust?: string;
    };
    url: "/timeseries/delta_ensemble_statistical_vector_data/";
};

export type GetDeltaEnsembleStatisticalVectorDataErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetDeltaEnsembleStatisticalVectorDataError_api =
    GetDeltaEnsembleStatisticalVectorDataErrors_api[keyof GetDeltaEnsembleStatisticalVectorDataErrors_api];

export type GetDeltaEnsembleStatisticalVectorDataResponses_api = {
    /**
     * Successful Response
     */
    200: VectorStatisticData_api;
};

export type GetDeltaEnsembleStatisticalVectorDataResponse_api =
    GetDeltaEnsembleStatisticalVectorDataResponses_api[keyof GetDeltaEnsembleStatisticalVectorDataResponses_api];

export type GetStatisticalVectorDataPerSensitivityData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Case Uuid
         *
         * Sumo case uuid
         */
        case_uuid: string;
        /**
         * Ensemble Name
         *
         * Ensemble name
         */
        ensemble_name: string;
        /**
         * Vector Name
         *
         * Name of the vector
         */
        vector_name: string;
        /**
         * Resampling frequency
         */
        resampling_frequency: Frequency_api;
        /**
         * Statistic Functions
         *
         * Optional list of statistics to calculate. If not specified, all statistics will be calculated.
         */
        statistic_functions?: Array<StatisticFunction_api> | null;
        /**
         * Realizations Encoded As Uint List Str
         *
         * Optional list of realizations to include. If not specified, all realizations will be included.
         */
        realizations_encoded_as_uint_list_str?: string | null;
        zCacheBust?: string;
    };
    url: "/timeseries/statistical_vector_data_per_sensitivity/";
};

export type GetStatisticalVectorDataPerSensitivityErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetStatisticalVectorDataPerSensitivityError_api =
    GetStatisticalVectorDataPerSensitivityErrors_api[keyof GetStatisticalVectorDataPerSensitivityErrors_api];

export type GetStatisticalVectorDataPerSensitivityResponses_api = {
    /**
     * Response Get Statistical Vector Data Per Sensitivity
     *
     * Successful Response
     */
    200: Array<VectorStatisticSensitivityData_api>;
};

export type GetStatisticalVectorDataPerSensitivityResponse_api =
    GetStatisticalVectorDataPerSensitivityResponses_api[keyof GetStatisticalVectorDataPerSensitivityResponses_api];

export type GetInplaceTableDefinitionsData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Case Uuid
         *
         * Sumo case uuid
         */
        case_uuid: string;
        /**
         * Ensemble Name
         *
         * Ensemble name
         */
        ensemble_name: string;
        zCacheBust?: string;
    };
    url: "/inplace_volumes/inplace_table_definitions/";
};

export type GetInplaceTableDefinitionsErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetInplaceTableDefinitionsError_api =
    GetInplaceTableDefinitionsErrors_api[keyof GetInplaceTableDefinitionsErrors_api];

export type GetInplaceTableDefinitionsResponses_api = {
    /**
     * Response Get Inplace Table Definitions
     *
     * Successful Response
     */
    200: Array<InplaceVolumesTableDefinition_api>;
};

export type GetInplaceTableDefinitionsResponse_api =
    GetInplaceTableDefinitionsResponses_api[keyof GetInplaceTableDefinitionsResponses_api];

export type PostGetAggregatedPerRealizationInplaceTableDataData_api = {
    body: BodyPostGetAggregatedPerRealizationInplaceTableData_api;
    path?: never;
    query: {
        /**
         * Case Uuid
         *
         * Sumo case uuid
         */
        case_uuid: string;
        /**
         * Ensemble Name
         *
         * Ensemble name
         */
        ensemble_name: string;
        /**
         * Table Name
         *
         * Table name
         */
        table_name: string;
        /**
         * Result Names
         *
         * The name of the inplace volumes results
         */
        result_names: Array<string>;
        /**
         * Group By Indices
         *
         * The indices to group table data by
         */
        group_by_indices?: Array<string> | null;
        /**
         * Realizations Encoded As Uint List Str
         *
         * Optional list of realizations encoded as string to include. If not specified, all realizations will be included.
         */
        realizations_encoded_as_uint_list_str?: string | null;
        zCacheBust?: string;
    };
    url: "/inplace_volumes/get_aggregated_per_realization_inplace_table_data/";
};

export type PostGetAggregatedPerRealizationInplaceTableDataErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type PostGetAggregatedPerRealizationInplaceTableDataError_api =
    PostGetAggregatedPerRealizationInplaceTableDataErrors_api[keyof PostGetAggregatedPerRealizationInplaceTableDataErrors_api];

export type PostGetAggregatedPerRealizationInplaceTableDataResponses_api = {
    /**
     * Successful Response
     */
    200: InplaceVolumesTableDataPerFluidSelection_api;
};

export type PostGetAggregatedPerRealizationInplaceTableDataResponse_api =
    PostGetAggregatedPerRealizationInplaceTableDataResponses_api[keyof PostGetAggregatedPerRealizationInplaceTableDataResponses_api];

export type PostGetAggregatedStatisticalInplaceTableDataData_api = {
    body: BodyPostGetAggregatedStatisticalInplaceTableData_api;
    path?: never;
    query: {
        /**
         * Case Uuid
         *
         * Sumo case uuid
         */
        case_uuid: string;
        /**
         * Ensemble Name
         *
         * Ensemble name
         */
        ensemble_name: string;
        /**
         * Table Name
         *
         * Table name
         */
        table_name: string;
        /**
         * Result Names
         *
         * The name of the inplace volumes results
         */
        result_names: Array<string>;
        /**
         * Group By Indices
         *
         * The indices to group table data by
         */
        group_by_indices?: Array<string> | null;
        /**
         * Realizations Encoded As Uint List Str
         *
         * Optional list of realizations encoded as string to include. If not specified, all realizations will be included.
         */
        realizations_encoded_as_uint_list_str?: string | null;
        zCacheBust?: string;
    };
    url: "/inplace_volumes/get_aggregated_statistical_inplace_table_data/";
};

export type PostGetAggregatedStatisticalInplaceTableDataErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type PostGetAggregatedStatisticalInplaceTableDataError_api =
    PostGetAggregatedStatisticalInplaceTableDataErrors_api[keyof PostGetAggregatedStatisticalInplaceTableDataErrors_api];

export type PostGetAggregatedStatisticalInplaceTableDataResponses_api = {
    /**
     * Successful Response
     */
    200: InplaceVolumesStatisticalTableDataPerFluidSelection_api;
};

export type PostGetAggregatedStatisticalInplaceTableDataResponse_api =
    PostGetAggregatedStatisticalInplaceTableDataResponses_api[keyof PostGetAggregatedStatisticalInplaceTableDataResponses_api];

export type GetRealizationSurfacesMetadataData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Case Uuid
         *
         * Sumo case uuid
         */
        case_uuid: string;
        /**
         * Ensemble Name
         *
         * Ensemble name
         */
        ensemble_name: string;
        zCacheBust?: string;
    };
    url: "/surface/realization_surfaces_metadata/";
};

export type GetRealizationSurfacesMetadataErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetRealizationSurfacesMetadataError_api =
    GetRealizationSurfacesMetadataErrors_api[keyof GetRealizationSurfacesMetadataErrors_api];

export type GetRealizationSurfacesMetadataResponses_api = {
    /**
     * Successful Response
     */
    200: SurfaceMetaSet_api;
};

export type GetRealizationSurfacesMetadataResponse_api =
    GetRealizationSurfacesMetadataResponses_api[keyof GetRealizationSurfacesMetadataResponses_api];

export type GetObservedSurfacesMetadataData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Case Uuid
         *
         * Sumo case uuid
         */
        case_uuid: string;
        zCacheBust?: string;
    };
    url: "/surface/observed_surfaces_metadata/";
};

export type GetObservedSurfacesMetadataErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetObservedSurfacesMetadataError_api =
    GetObservedSurfacesMetadataErrors_api[keyof GetObservedSurfacesMetadataErrors_api];

export type GetObservedSurfacesMetadataResponses_api = {
    /**
     * Successful Response
     */
    200: SurfaceMetaSet_api;
};

export type GetObservedSurfacesMetadataResponse_api =
    GetObservedSurfacesMetadataResponses_api[keyof GetObservedSurfacesMetadataResponses_api];

export type GetInitialFluidContactSurfacesMetadataData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Case Uuid
         *
         * Sumo case uuid
         */
        case_uuid: string;
        /**
         * Ensemble Name
         *
         * Ensemble name
         */
        ensemble_name: string;
        zCacheBust?: string;
    };
    url: "/surface/initial_fluid_contact_surfaces_metadata/";
};

export type GetInitialFluidContactSurfacesMetadataErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetInitialFluidContactSurfacesMetadataError_api =
    GetInitialFluidContactSurfacesMetadataErrors_api[keyof GetInitialFluidContactSurfacesMetadataErrors_api];

export type GetInitialFluidContactSurfacesMetadataResponses_api = {
    /**
     * Response Get Initial Fluid Contact Surfaces Metadata
     *
     * Successful Response
     */
    200: Array<InitialFluidContactSurfaceMeta_api>;
};

export type GetInitialFluidContactSurfacesMetadataResponse_api =
    GetInitialFluidContactSurfacesMetadataResponses_api[keyof GetInitialFluidContactSurfacesMetadataResponses_api];

export type GetSurfaceDataData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Surf Addr Str
         *
         * Surface address string, supported address types are *REAL*, *OBS* and *STAT*
         */
        surf_addr_str: string;
        /**
         * Data Format
         *
         * Format of binary data in the response
         */
        data_format?: "float" | "png";
        /**
         * Resample To Def Str
         *
         * Definition of the surface onto which the data should be resampled. *SurfaceDef* object properties encoded as a `KeyValStr` string.
         */
        resample_to_def_str?: string | null;
        zCacheBust?: string;
    };
    url: "/surface/surface_data";
};

export type GetSurfaceDataErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetSurfaceDataError_api = GetSurfaceDataErrors_api[keyof GetSurfaceDataErrors_api];

export type GetSurfaceDataResponses_api = {
    /**
     * Response Get Surface Data
     *
     * Successful Response
     */
    200: SurfaceDataFloat_api | SurfaceDataPng_api;
};

export type GetSurfaceDataResponse_api = GetSurfaceDataResponses_api[keyof GetSurfaceDataResponses_api];

export type PostGetWellTrajectoriesFormationSegmentsData_api = {
    body: BodyPostGetWellTrajectoriesFormationSegments_api;
    path?: never;
    query: {
        /**
         * Top Depth Surf Addr Str
         *
         * Surface address string for top bounding depth surface. Supported address types are *REAL*, *OBS* and *STAT*
         */
        top_depth_surf_addr_str: string;
        /**
         * Bottom Depth Surf Addr Str
         *
         * Optional surface address string for bottom bounding depth surface. If not provided end of well trajectory is used as lower bound for formation. Supported address types are *REAL*, *OBS* and *STAT*
         */
        bottom_depth_surf_addr_str?: string | null;
        zCacheBust?: string;
    };
    url: "/surface/get_well_trajectories_formation_segments";
};

export type PostGetWellTrajectoriesFormationSegmentsErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type PostGetWellTrajectoriesFormationSegmentsError_api =
    PostGetWellTrajectoriesFormationSegmentsErrors_api[keyof PostGetWellTrajectoriesFormationSegmentsErrors_api];

export type PostGetWellTrajectoriesFormationSegmentsResponses_api = {
    /**
     * Response Post Get Well Trajectories Formation Segments
     *
     * Successful Response
     */
    200: Array<WellTrajectoryFormationSegments_api>;
};

export type PostGetWellTrajectoriesFormationSegmentsResponse_api =
    PostGetWellTrajectoriesFormationSegmentsResponses_api[keyof PostGetWellTrajectoriesFormationSegmentsResponses_api];

export type GetStatisticalSurfaceDataHybridData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Surf Addr Str
         *
         * Surface address string, supported address type is *STAT*
         */
        surf_addr_str: string;
        /**
         * Data Format
         *
         * Format of binary data in the response
         */
        data_format?: "float" | "png";
        /**
         * Delete Task
         *
         * If true, deletes the server-side task metadata for this surface address
         */
        delete_task?: boolean;
        /**
         * Resample To Def Str
         *
         * Definition of the surface onto which the data should be resampled. *SurfaceDef* object properties encoded as a `KeyValStr` string.
         */
        resample_to_def_str?: string | null;
        zCacheBust?: string;
    };
    url: "/surface/statistical_surface_data_hybrid";
};

export type GetStatisticalSurfaceDataHybridErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetStatisticalSurfaceDataHybridError_api =
    GetStatisticalSurfaceDataHybridErrors_api[keyof GetStatisticalSurfaceDataHybridErrors_api];

export type GetStatisticalSurfaceDataHybridResponses_api = {
    /**
     * Response Get Statistical Surface Data Hybrid
     *
     * Successful Response
     */
    200:
        | LroSuccessRespUnionSurfaceDataFloatSurfaceDataPng_api
        | LroInProgressResp_api
        | LroFailureResp_api
        | LroCommandResp_api;
};

export type GetStatisticalSurfaceDataHybridResponse_api =
    GetStatisticalSurfaceDataHybridResponses_api[keyof GetStatisticalSurfaceDataHybridResponses_api];

export type PostGetSurfaceIntersectionData_api = {
    body: BodyPostGetSurfaceIntersection_api;
    path?: never;
    query: {
        /**
         * Surf Addr Str
         *
         * Surface address string, supported address types are *REAL*, *OBS* and *STAT*
         */
        surf_addr_str: string;
        zCacheBust?: string;
    };
    url: "/surface/get_surface_intersection";
};

export type PostGetSurfaceIntersectionErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type PostGetSurfaceIntersectionError_api =
    PostGetSurfaceIntersectionErrors_api[keyof PostGetSurfaceIntersectionErrors_api];

export type PostGetSurfaceIntersectionResponses_api = {
    /**
     * Successful Response
     */
    200: SurfaceIntersectionData_api;
};

export type PostGetSurfaceIntersectionResponse_api =
    PostGetSurfaceIntersectionResponses_api[keyof PostGetSurfaceIntersectionResponses_api];

export type PostGetSampleSurfaceInPointsData_api = {
    body: BodyPostGetSampleSurfaceInPoints_api;
    path?: never;
    query: {
        /**
         * Case Uuid
         *
         * Sumo case uuid
         */
        case_uuid: string;
        /**
         * Ensemble Name
         *
         * Ensemble name
         */
        ensemble_name: string;
        /**
         * Surface Name
         *
         * Surface name
         */
        surface_name: string;
        /**
         * Realization Nums
         *
         * Realization numbers
         */
        realization_nums: Array<number>;
        zCacheBust?: string;
    };
    url: "/surface/get_sample_surface_in_points";
};

export type PostGetSampleSurfaceInPointsErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type PostGetSampleSurfaceInPointsError_api =
    PostGetSampleSurfaceInPointsErrors_api[keyof PostGetSampleSurfaceInPointsErrors_api];

export type PostGetSampleSurfaceInPointsResponses_api = {
    /**
     * Response Post Get Sample Surface In Points
     *
     * Successful Response
     */
    200: Array<SurfaceRealizationSampleValues_api>;
};

export type PostGetSampleSurfaceInPointsResponse_api =
    PostGetSampleSurfaceInPointsResponses_api[keyof PostGetSampleSurfaceInPointsResponses_api];

export type GetDeltaSurfaceDataData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Surf A Addr Str
         *
         * Address string of surface A, supported types: *REAL*, *OBS* and *STAT*
         */
        surf_a_addr_str: string;
        /**
         * Surf B Addr Str
         *
         * Address string of surface B, supported types: *REAL*, *OBS* and *STAT*
         */
        surf_b_addr_str: string;
        /**
         * Data Format
         *
         * Format of binary data in the response
         */
        data_format?: "float" | "png";
        /**
         * Resample To Def Str
         *
         * Definition of the surface onto which the data should be resampled. *SurfaceDef* object properties encoded as a `KeyValStr` string.
         */
        resample_to_def_str?: string | null;
        zCacheBust?: string;
    };
    url: "/surface/delta_surface_data";
};

export type GetDeltaSurfaceDataErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetDeltaSurfaceDataError_api = GetDeltaSurfaceDataErrors_api[keyof GetDeltaSurfaceDataErrors_api];

export type GetDeltaSurfaceDataResponses_api = {
    /**
     * Response Get Delta Surface Data
     *
     * Successful Response
     */
    200: Array<SurfaceDataFloat_api>;
};

export type GetDeltaSurfaceDataResponse_api = GetDeltaSurfaceDataResponses_api[keyof GetDeltaSurfaceDataResponses_api];

export type GetMisfitSurfaceDataData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Obs Surf Addr Str
         *
         * Address of observed surface, only supported address type is *OBS*
         */
        obs_surf_addr_str: string;
        /**
         * Sim Surf Addr Str
         *
         * Address of simulated surface, only supported address type is *REAL*
         */
        sim_surf_addr_str: string;
        /**
         * Statistic Functions
         *
         * Statistics to calculate
         */
        statistic_functions: Array<SurfaceStatisticFunction_api>;
        /**
         * Realizations Encoded As Uint List Str
         *
         * Optional list of realizations encoded as string to include. If not specified, all realizations will be included.
         */
        realizations_encoded_as_uint_list_str?: string | null;
        /**
         * Data Format
         *
         * Format of binary data in the response
         */
        data_format?: "float" | "png";
        /**
         * Resample To Def Str
         *
         * Definition of the surface onto which the data should be resampled. *SurfaceDef* object properties encoded as a `KeyValStr` string.
         */
        resample_to_def_str?: string | null;
        zCacheBust?: string;
    };
    url: "/surface/misfit_surface_data";
};

export type GetMisfitSurfaceDataErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetMisfitSurfaceDataError_api = GetMisfitSurfaceDataErrors_api[keyof GetMisfitSurfaceDataErrors_api];

export type GetMisfitSurfaceDataResponses_api = {
    /**
     * Response Get Misfit Surface Data
     *
     * Successful Response
     */
    200: Array<SurfaceDataFloat_api>;
};

export type GetMisfitSurfaceDataResponse_api =
    GetMisfitSurfaceDataResponses_api[keyof GetMisfitSurfaceDataResponses_api];

export type GetParametersAndSensitivitiesData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Case Uuid
         *
         * Sumo case uuid
         */
        case_uuid: string;
        /**
         * Ensemble Name
         *
         * Ensemble name
         */
        ensemble_name: string;
        zCacheBust?: string;
    };
    url: "/parameters/parameters_and_sensitivities/";
};

export type GetParametersAndSensitivitiesErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetParametersAndSensitivitiesError_api =
    GetParametersAndSensitivitiesErrors_api[keyof GetParametersAndSensitivitiesErrors_api];

export type GetParametersAndSensitivitiesResponses_api = {
    /**
     * Successful Response
     */
    200: EnsembleParametersAndSensitivities_api;
};

export type GetParametersAndSensitivitiesResponse_api =
    GetParametersAndSensitivitiesResponses_api[keyof GetParametersAndSensitivitiesResponses_api];

export type GetGridModelsInfoData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Case Uuid
         *
         * Sumo case uuid
         */
        case_uuid: string;
        /**
         * Ensemble Name
         *
         * Ensemble name
         */
        ensemble_name: string;
        /**
         * Realization Num
         *
         * Realization
         */
        realization_num: number;
        zCacheBust?: string;
    };
    url: "/grid3d/grid_models_info/";
};

export type GetGridModelsInfoErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetGridModelsInfoError_api = GetGridModelsInfoErrors_api[keyof GetGridModelsInfoErrors_api];

export type GetGridModelsInfoResponses_api = {
    /**
     * Response Get Grid Models Info
     *
     * Successful Response
     */
    200: Array<Grid3dInfo_api>;
};

export type GetGridModelsInfoResponse_api = GetGridModelsInfoResponses_api[keyof GetGridModelsInfoResponses_api];

export type GetGridSurfaceData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Case Uuid
         *
         * Sumo case uuid
         */
        case_uuid: string;
        /**
         * Ensemble Name
         *
         * Ensemble name
         */
        ensemble_name: string;
        /**
         * Grid Name
         *
         * Grid name
         */
        grid_name: string;
        /**
         * Realization Num
         *
         * Realization
         */
        realization_num: number;
        /**
         * I Min
         *
         * Min i index
         */
        i_min?: number;
        /**
         * I Max
         *
         * Max i index
         */
        i_max?: number;
        /**
         * J Min
         *
         * Min j index
         */
        j_min?: number;
        /**
         * J Max
         *
         * Max j index
         */
        j_max?: number;
        /**
         * K Min
         *
         * Min k index
         */
        k_min?: number;
        /**
         * K Max
         *
         * Max k index
         */
        k_max?: number;
        zCacheBust?: string;
    };
    url: "/grid3d/grid_surface";
};

export type GetGridSurfaceErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetGridSurfaceError_api = GetGridSurfaceErrors_api[keyof GetGridSurfaceErrors_api];

export type GetGridSurfaceResponses_api = {
    /**
     * Successful Response
     */
    200: Grid3dGeometry_api;
};

export type GetGridSurfaceResponse_api = GetGridSurfaceResponses_api[keyof GetGridSurfaceResponses_api];

export type GetGridParameterData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Case Uuid
         *
         * Sumo case uuid
         */
        case_uuid: string;
        /**
         * Ensemble Name
         *
         * Ensemble name
         */
        ensemble_name: string;
        /**
         * Grid Name
         *
         * Grid name
         */
        grid_name: string;
        /**
         * Parameter Name
         *
         * Grid parameter
         */
        parameter_name: string;
        /**
         * Realization Num
         *
         * Realization
         */
        realization_num: number;
        /**
         * Parameter Time Or Interval Str
         *
         * Time point or time interval string
         */
        parameter_time_or_interval_str?: string | null;
        /**
         * I Min
         *
         * Min i index
         */
        i_min?: number;
        /**
         * I Max
         *
         * Max i index
         */
        i_max?: number;
        /**
         * J Min
         *
         * Min j index
         */
        j_min?: number;
        /**
         * J Max
         *
         * Max j index
         */
        j_max?: number;
        /**
         * K Min
         *
         * Min k index
         */
        k_min?: number;
        /**
         * K Max
         *
         * Max k index
         */
        k_max?: number;
        zCacheBust?: string;
    };
    url: "/grid3d/grid_parameter";
};

export type GetGridParameterErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetGridParameterError_api = GetGridParameterErrors_api[keyof GetGridParameterErrors_api];

export type GetGridParameterResponses_api = {
    /**
     * Successful Response
     */
    200: Grid3dMappedProperty_api;
};

export type GetGridParameterResponse_api = GetGridParameterResponses_api[keyof GetGridParameterResponses_api];

export type PostGetPolylineIntersectionData_api = {
    body: BodyPostGetPolylineIntersection_api;
    path?: never;
    query: {
        /**
         * Case Uuid
         *
         * Sumo case uuid
         */
        case_uuid: string;
        /**
         * Ensemble Name
         *
         * Ensemble name
         */
        ensemble_name: string;
        /**
         * Grid Name
         *
         * Grid name
         */
        grid_name: string;
        /**
         * Parameter Name
         *
         * Grid parameter
         */
        parameter_name: string;
        /**
         * Realization Num
         *
         * Realization
         */
        realization_num: number;
        /**
         * Parameter Time Or Interval Str
         *
         * Time point or time interval string
         */
        parameter_time_or_interval_str?: string | null;
        zCacheBust?: string;
    };
    url: "/grid3d/get_polyline_intersection";
};

export type PostGetPolylineIntersectionErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type PostGetPolylineIntersectionError_api =
    PostGetPolylineIntersectionErrors_api[keyof PostGetPolylineIntersectionErrors_api];

export type PostGetPolylineIntersectionResponses_api = {
    /**
     * Successful Response
     */
    200: PolylineIntersection_api;
};

export type PostGetPolylineIntersectionResponse_api =
    PostGetPolylineIntersectionResponses_api[keyof PostGetPolylineIntersectionResponses_api];

export type GetRealizationFlowNetworkData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Case Uuid
         *
         * Sumo case uuid
         */
        case_uuid: string;
        /**
         * Ensemble Name
         *
         * Ensemble name
         */
        ensemble_name: string;
        /**
         * Realization
         *
         * Realization
         */
        realization: number;
        /**
         * Resampling frequency
         */
        resampling_frequency: Frequency_api;
        /**
         * Node Type Set
         *
         * Node types
         */
        node_type_set: Array<NodeType_api>;
        zCacheBust?: string;
    };
    url: "/flow_network/realization_flow_network/";
};

export type GetRealizationFlowNetworkErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetRealizationFlowNetworkError_api =
    GetRealizationFlowNetworkErrors_api[keyof GetRealizationFlowNetworkErrors_api];

export type GetRealizationFlowNetworkResponses_api = {
    /**
     * Successful Response
     */
    200: FlowNetworkPerTreeType_api;
};

export type GetRealizationFlowNetworkResponse_api =
    GetRealizationFlowNetworkResponses_api[keyof GetRealizationFlowNetworkResponses_api];

export type GetProductionDataData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Field Identifier
         *
         * Official field identifier
         */
        field_identifier: string;
        /**
         * Start Date
         *
         * Start date in YYYY-MM-DD
         */
        start_date: string;
        /**
         * End Date
         *
         * End date in YYYY-MM-DD
         */
        end_date: string;
        zCacheBust?: string;
    };
    url: "/flow_data/production_data/";
};

export type GetProductionDataErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetProductionDataError_api = GetProductionDataErrors_api[keyof GetProductionDataErrors_api];

export type GetProductionDataResponses_api = {
    /**
     * Response Get Production Data
     *
     * Successful Response
     */
    200: Array<WellProductionData_api>;
};

export type GetProductionDataResponse_api = GetProductionDataResponses_api[keyof GetProductionDataResponses_api];

export type GetInjectionDataData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Field Identifier
         *
         * Official field identifier
         */
        field_identifier: string;
        /**
         * Start Date
         *
         * Start date in YYYY-MM-DD
         */
        start_date: string;
        /**
         * End Date
         *
         * End date in YYYY-MM-DD
         */
        end_date: string;
        zCacheBust?: string;
    };
    url: "/flow_data/injection_data/";
};

export type GetInjectionDataErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetInjectionDataError_api = GetInjectionDataErrors_api[keyof GetInjectionDataErrors_api];

export type GetInjectionDataResponses_api = {
    /**
     * Response Get Injection Data
     *
     * Successful Response
     */
    200: Array<WellInjectionData_api>;
};

export type GetInjectionDataResponse_api = GetInjectionDataResponses_api[keyof GetInjectionDataResponses_api];

export type GetPvtTableDataData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Case Uuid
         *
         * Sumo case uuid
         */
        case_uuid: string;
        /**
         * Ensemble Name
         *
         * Ensemble name
         */
        ensemble_name: string;
        /**
         * Realization
         *
         * Realization number
         */
        realization: number;
        zCacheBust?: string;
    };
    url: "/pvt/pvt_table_data/";
};

export type GetPvtTableDataErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetPvtTableDataError_api = GetPvtTableDataErrors_api[keyof GetPvtTableDataErrors_api];

export type GetPvtTableDataResponses_api = {
    /**
     * Response Get Pvt Table Data
     *
     * Successful Response
     */
    200: Array<PvtData_api>;
};

export type GetPvtTableDataResponse_api = GetPvtTableDataResponses_api[keyof GetPvtTableDataResponses_api];

export type GetWellCompletionsDataData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Case Uuid
         *
         * Sumo case uuid
         */
        case_uuid: string;
        /**
         * Ensemble Name
         *
         * Ensemble name
         */
        ensemble_name: string;
        /**
         * Realizations Encoded As Uint List Str
         *
         * Optional realizations to include, list encoded as string. If not specified, all realizations will be returned.
         */
        realizations_encoded_as_uint_list_str?: number | string | null;
        zCacheBust?: string;
    };
    url: "/well_completions/well_completions_data/";
};

export type GetWellCompletionsDataErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetWellCompletionsDataError_api = GetWellCompletionsDataErrors_api[keyof GetWellCompletionsDataErrors_api];

export type GetWellCompletionsDataResponses_api = {
    /**
     * Successful Response
     */
    200: WellCompletionsData_api;
};

export type GetWellCompletionsDataResponse_api =
    GetWellCompletionsDataResponses_api[keyof GetWellCompletionsDataResponses_api];

export type GetDrilledWellboreHeadersData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Field Identifier
         *
         * Official field identifier
         */
        field_identifier: string;
        zCacheBust?: string;
    };
    url: "/well/drilled_wellbore_headers/";
};

export type GetDrilledWellboreHeadersErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetDrilledWellboreHeadersError_api =
    GetDrilledWellboreHeadersErrors_api[keyof GetDrilledWellboreHeadersErrors_api];

export type GetDrilledWellboreHeadersResponses_api = {
    /**
     * Response Get Drilled Wellbore Headers
     *
     * Successful Response
     */
    200: Array<WellboreHeader_api>;
};

export type GetDrilledWellboreHeadersResponse_api =
    GetDrilledWellboreHeadersResponses_api[keyof GetDrilledWellboreHeadersResponses_api];

export type GetPlannedWellboreHeadersData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Field Identifier
         *
         * Official field identifier
         */
        field_identifier: string;
        zCacheBust?: string;
    };
    url: "/well/planned_wellbore_headers/";
};

export type GetPlannedWellboreHeadersErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetPlannedWellboreHeadersError_api =
    GetPlannedWellboreHeadersErrors_api[keyof GetPlannedWellboreHeadersErrors_api];

export type GetPlannedWellboreHeadersResponses_api = {
    /**
     * Response Get Planned Wellbore Headers
     *
     * Successful Response
     */
    200: Array<WellboreHeader_api>;
};

export type GetPlannedWellboreHeadersResponse_api =
    GetPlannedWellboreHeadersResponses_api[keyof GetPlannedWellboreHeadersResponses_api];

export type GetFieldPerforationsData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Field Identifier
         *
         * Official field identifier
         */
        field_identifier: string;
        zCacheBust?: string;
    };
    url: "/well/field_perforations";
};

export type GetFieldPerforationsErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetFieldPerforationsError_api = GetFieldPerforationsErrors_api[keyof GetFieldPerforationsErrors_api];

export type GetFieldPerforationsResponses_api = {
    /**
     * Response Get Field Perforations
     *
     * Successful Response
     */
    200: Array<WellborePerforations_api>;
};

export type GetFieldPerforationsResponse_api =
    GetFieldPerforationsResponses_api[keyof GetFieldPerforationsResponses_api];

export type GetFieldScreensData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Field Identifier
         *
         * Official field identifier
         */
        field_identifier: string;
        zCacheBust?: string;
    };
    url: "/well/field_screens";
};

export type GetFieldScreensErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetFieldScreensError_api = GetFieldScreensErrors_api[keyof GetFieldScreensErrors_api];

export type GetFieldScreensResponses_api = {
    /**
     * Response Get Field Screens
     *
     * Successful Response
     */
    200: Array<WellboreCompletions_api>;
};

export type GetFieldScreensResponse_api = GetFieldScreensResponses_api[keyof GetFieldScreensResponses_api];

export type GetWellTrajectoriesData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Field Identifier
         *
         * Official field identifier
         */
        field_identifier: string;
        /**
         * Wellbore Uuids
         *
         * Optional subset of wellbore uuids
         */
        wellbore_uuids?: Array<string> | null;
        zCacheBust?: string;
    };
    url: "/well/well_trajectories/";
};

export type GetWellTrajectoriesErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetWellTrajectoriesError_api = GetWellTrajectoriesErrors_api[keyof GetWellTrajectoriesErrors_api];

export type GetWellTrajectoriesResponses_api = {
    /**
     * Response Get Well Trajectories
     *
     * Successful Response
     */
    200: Array<WellboreTrajectory_api>;
};

export type GetWellTrajectoriesResponse_api = GetWellTrajectoriesResponses_api[keyof GetWellTrajectoriesResponses_api];

export type GetPlannedWellTrajectoriesData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Field Identifier
         *
         * Official field identifier
         */
        field_identifier: string;
        /**
         * Wellbore Uuids
         *
         * Optional subset of planned wellbore uuids
         */
        wellbore_uuids?: Array<string> | null;
        zCacheBust?: string;
    };
    url: "/well/planned_well_trajectories/";
};

export type GetPlannedWellTrajectoriesErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetPlannedWellTrajectoriesError_api =
    GetPlannedWellTrajectoriesErrors_api[keyof GetPlannedWellTrajectoriesErrors_api];

export type GetPlannedWellTrajectoriesResponses_api = {
    /**
     * Response Get Planned Well Trajectories
     *
     * Successful Response
     */
    200: Array<WellboreTrajectory_api>;
};

export type GetPlannedWellTrajectoriesResponse_api =
    GetPlannedWellTrajectoriesResponses_api[keyof GetPlannedWellTrajectoriesResponses_api];

export type GetWellborePickIdentifiersData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Strat Column Identifier
         *
         * Stratigraphic column identifier
         */
        strat_column_identifier: string;
        zCacheBust?: string;
    };
    url: "/well/wellbore_pick_identifiers/";
};

export type GetWellborePickIdentifiersErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetWellborePickIdentifiersError_api =
    GetWellborePickIdentifiersErrors_api[keyof GetWellborePickIdentifiersErrors_api];

export type GetWellborePickIdentifiersResponses_api = {
    /**
     * Response Get Wellbore Pick Identifiers
     *
     * Successful Response
     */
    200: Array<string>;
};

export type GetWellborePickIdentifiersResponse_api =
    GetWellborePickIdentifiersResponses_api[keyof GetWellborePickIdentifiersResponses_api];

export type GetWellborePicksForPickIdentifierData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Field Identifier
         *
         * Official field identifier
         */
        field_identifier: string;
        /**
         * Pick Identifier
         *
         * Pick identifier
         */
        pick_identifier: string;
        zCacheBust?: string;
    };
    url: "/well/wellbore_picks_for_pick_identifier/";
};

export type GetWellborePicksForPickIdentifierErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetWellborePicksForPickIdentifierError_api =
    GetWellborePicksForPickIdentifierErrors_api[keyof GetWellborePicksForPickIdentifierErrors_api];

export type GetWellborePicksForPickIdentifierResponses_api = {
    /**
     * Response Get Wellbore Picks For Pick Identifier
     *
     * Successful Response
     */
    200: Array<WellborePick_api>;
};

export type GetWellborePicksForPickIdentifierResponse_api =
    GetWellborePicksForPickIdentifierResponses_api[keyof GetWellborePicksForPickIdentifierResponses_api];

export type GetWellborePicksInStratColumnData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Wellbore Uuid
         *
         * Wellbore uuid
         */
        wellbore_uuid: string;
        /**
         * Strat Column Identifier
         *
         * Filter by stratigraphic column
         */
        strat_column_identifier: string;
        zCacheBust?: string;
    };
    url: "/well/wellbore_picks_in_strat_column";
};

export type GetWellborePicksInStratColumnErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetWellborePicksInStratColumnError_api =
    GetWellborePicksInStratColumnErrors_api[keyof GetWellborePicksInStratColumnErrors_api];

export type GetWellborePicksInStratColumnResponses_api = {
    /**
     * Response Get Wellbore Picks In Strat Column
     *
     * Successful Response
     */
    200: Array<WellborePick_api>;
};

export type GetWellborePicksInStratColumnResponse_api =
    GetWellborePicksInStratColumnResponses_api[keyof GetWellborePicksInStratColumnResponses_api];

export type GetWellboreStratigraphicColumnsData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Wellbore Uuid
         *
         * Wellbore uuid
         */
        wellbore_uuid: string;
        zCacheBust?: string;
    };
    url: "/well/wellbore_stratigraphic_columns/";
};

export type GetWellboreStratigraphicColumnsErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetWellboreStratigraphicColumnsError_api =
    GetWellboreStratigraphicColumnsErrors_api[keyof GetWellboreStratigraphicColumnsErrors_api];

export type GetWellboreStratigraphicColumnsResponses_api = {
    /**
     * Response Get Wellbore Stratigraphic Columns
     *
     * Successful Response
     */
    200: Array<StratigraphicColumn_api>;
};

export type GetWellboreStratigraphicColumnsResponse_api =
    GetWellboreStratigraphicColumnsResponses_api[keyof GetWellboreStratigraphicColumnsResponses_api];

export type GetWellboreCompletionsData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Wellbore Uuid
         *
         * Wellbore uuid
         */
        wellbore_uuid: string;
        zCacheBust?: string;
    };
    url: "/well/wellbore_completions/";
};

export type GetWellboreCompletionsErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetWellboreCompletionsError_api = GetWellboreCompletionsErrors_api[keyof GetWellboreCompletionsErrors_api];

export type GetWellboreCompletionsResponses_api = {
    /**
     * Response Get Wellbore Completions
     *
     * Successful Response
     */
    200: Array<WellboreCompletion_api>;
};

export type GetWellboreCompletionsResponse_api =
    GetWellboreCompletionsResponses_api[keyof GetWellboreCompletionsResponses_api];

export type GetWellboreCasingsData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Wellbore Uuid
         *
         * Wellbore uuid
         */
        wellbore_uuid: string;
        zCacheBust?: string;
    };
    url: "/well/wellbore_casings/";
};

export type GetWellboreCasingsErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetWellboreCasingsError_api = GetWellboreCasingsErrors_api[keyof GetWellboreCasingsErrors_api];

export type GetWellboreCasingsResponses_api = {
    /**
     * Response Get Wellbore Casings
     *
     * Successful Response
     */
    200: Array<WellboreCasing_api>;
};

export type GetWellboreCasingsResponse_api = GetWellboreCasingsResponses_api[keyof GetWellboreCasingsResponses_api];

export type GetWellborePerforationsData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Wellbore Uuid
         *
         * Wellbore uuid
         */
        wellbore_uuid: string;
        zCacheBust?: string;
    };
    url: "/well/wellbore_perforations/";
};

export type GetWellborePerforationsErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetWellborePerforationsError_api =
    GetWellborePerforationsErrors_api[keyof GetWellborePerforationsErrors_api];

export type GetWellborePerforationsResponses_api = {
    /**
     * Response Get Wellbore Perforations
     *
     * Successful Response
     */
    200: Array<WellborePerforation_api>;
};

export type GetWellborePerforationsResponse_api =
    GetWellborePerforationsResponses_api[keyof GetWellborePerforationsResponses_api];

export type GetWellboreLogCurveHeadersData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Wellbore Uuid
         *
         * Wellbore uuid
         */
        wellbore_uuid: string;
        /**
         * Sources
         *
         * Sources to fetch well-logs from.
         */
        sources?: Array<WellLogCurveSourceEnum_api>;
        zCacheBust?: string;
    };
    url: "/well/wellbore_log_curve_headers/";
};

export type GetWellboreLogCurveHeadersErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetWellboreLogCurveHeadersError_api =
    GetWellboreLogCurveHeadersErrors_api[keyof GetWellboreLogCurveHeadersErrors_api];

export type GetWellboreLogCurveHeadersResponses_api = {
    /**
     * Response Get Wellbore Log Curve Headers
     *
     * Successful Response
     */
    200: Array<WellboreLogCurveHeader_api>;
};

export type GetWellboreLogCurveHeadersResponse_api =
    GetWellboreLogCurveHeadersResponses_api[keyof GetWellboreLogCurveHeadersResponses_api];

export type GetLogCurveDataData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Wellbore Uuid
         *
         * Wellbore uuid
         */
        wellbore_uuid: string;
        /**
         * Log Name
         *
         * Log identifier
         */
        log_name: string;
        /**
         * Curve Name
         *
         * Curve identifier
         */
        curve_name: string;
        /**
         * Source to fetch well-logs from.
         */
        source?: WellLogCurveSourceEnum_api;
        zCacheBust?: string;
    };
    url: "/well/log_curve_data/";
};

export type GetLogCurveDataErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetLogCurveDataError_api = GetLogCurveDataErrors_api[keyof GetLogCurveDataErrors_api];

export type GetLogCurveDataResponses_api = {
    /**
     * Successful Response
     */
    200: WellboreLogCurveData_api;
};

export type GetLogCurveDataResponse_api = GetLogCurveDataResponses_api[keyof GetLogCurveDataResponses_api];

export type GetSeismicCubeMetaListData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Case Uuid
         *
         * Sumo case uuid
         */
        case_uuid: string;
        /**
         * Ensemble Name
         *
         * Ensemble name
         */
        ensemble_name: string;
        zCacheBust?: string;
    };
    url: "/seismic/seismic_cube_meta_list/";
};

export type GetSeismicCubeMetaListErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetSeismicCubeMetaListError_api = GetSeismicCubeMetaListErrors_api[keyof GetSeismicCubeMetaListErrors_api];

export type GetSeismicCubeMetaListResponses_api = {
    /**
     * Response Get Seismic Cube Meta List
     *
     * Successful Response
     */
    200: Array<SeismicCubeMeta_api>;
};

export type GetSeismicCubeMetaListResponse_api =
    GetSeismicCubeMetaListResponses_api[keyof GetSeismicCubeMetaListResponses_api];

export type GetSeismicSlicesData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Case Uuid
         *
         * Sumo case uuid
         */
        case_uuid: string;
        /**
         * Ensemble Name
         *
         * Ensemble name
         */
        ensemble_name: string;
        /**
         * Realization Num
         *
         * Realization number
         */
        realization_num: number;
        /**
         * Seismic Attribute
         *
         * Seismic cube attribute
         */
        seismic_attribute: string;
        /**
         * Time Or Interval Str
         *
         * Timestamp or timestep
         */
        time_or_interval_str: string;
        /**
         * Seismic representation
         */
        representation: SeismicRepresentation_api;
        /**
         * Inline Number
         *
         * Inline number
         */
        inline_number: number;
        /**
         * Crossline Number
         *
         * Crossline number
         */
        crossline_number: number;
        /**
         * Depth Slice Number
         *
         * Depth slice number
         */
        depth_slice_number: number;
        zCacheBust?: string;
    };
    url: "/seismic/get_seismic_slices/";
};

export type GetSeismicSlicesErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetSeismicSlicesError_api = GetSeismicSlicesErrors_api[keyof GetSeismicSlicesErrors_api];

export type GetSeismicSlicesResponses_api = {
    /**
     * Response Get Seismic Slices
     *
     * Successful Response
     */
    200: [SeismicSliceData_api, SeismicSliceData_api, SeismicSliceData_api];
};

export type GetSeismicSlicesResponse_api = GetSeismicSlicesResponses_api[keyof GetSeismicSlicesResponses_api];

export type PostGetSeismicFenceData_api = {
    body: BodyPostGetSeismicFence_api;
    path?: never;
    query: {
        /**
         * Case Uuid
         *
         * Sumo case uuid
         */
        case_uuid: string;
        /**
         * Ensemble Name
         *
         * Ensemble name
         */
        ensemble_name: string;
        /**
         * Realization Num
         *
         * Realization number
         */
        realization_num: number;
        /**
         * Seismic Attribute
         *
         * Seismic cube attribute
         */
        seismic_attribute: string;
        /**
         * Time Or Interval Str
         *
         * Timestamp or timestep
         */
        time_or_interval_str: string;
        /**
         * Seismic representation
         */
        representation: SeismicRepresentation_api;
        zCacheBust?: string;
    };
    url: "/seismic/get_seismic_fence/";
};

export type PostGetSeismicFenceErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type PostGetSeismicFenceError_api = PostGetSeismicFenceErrors_api[keyof PostGetSeismicFenceErrors_api];

export type PostGetSeismicFenceResponses_api = {
    /**
     * Successful Response
     */
    200: SeismicFenceData_api;
};

export type PostGetSeismicFenceResponse_api = PostGetSeismicFenceResponses_api[keyof PostGetSeismicFenceResponses_api];

export type GetPolygonsDirectoryData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Case Uuid
         *
         * Sumo case uuid
         */
        case_uuid: string;
        /**
         * Ensemble Name
         *
         * Ensemble name
         */
        ensemble_name: string;
        zCacheBust?: string;
    };
    url: "/polygons/polygons_directory/";
};

export type GetPolygonsDirectoryErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetPolygonsDirectoryError_api = GetPolygonsDirectoryErrors_api[keyof GetPolygonsDirectoryErrors_api];

export type GetPolygonsDirectoryResponses_api = {
    /**
     * Response Get Polygons Directory
     *
     * Successful Response
     */
    200: Array<PolygonsMeta_api>;
};

export type GetPolygonsDirectoryResponse_api =
    GetPolygonsDirectoryResponses_api[keyof GetPolygonsDirectoryResponses_api];

export type GetPolygonsDataData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Case Uuid
         *
         * Sumo case uuid
         */
        case_uuid: string;
        /**
         * Ensemble Name
         *
         * Ensemble name
         */
        ensemble_name: string;
        /**
         * Realization Num
         *
         * Realization number
         */
        realization_num: number;
        /**
         * Name
         *
         * Surface name
         */
        name: string;
        /**
         * Attribute
         *
         * Surface attribute
         */
        attribute: string;
        zCacheBust?: string;
    };
    url: "/polygons/polygons_data/";
};

export type GetPolygonsDataErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetPolygonsDataError_api = GetPolygonsDataErrors_api[keyof GetPolygonsDataErrors_api];

export type GetPolygonsDataResponses_api = {
    /**
     * Response Get Polygons Data
     *
     * Successful Response
     */
    200: Array<PolygonData_api>;
};

export type GetPolygonsDataResponse_api = GetPolygonsDataResponses_api[keyof GetPolygonsDataResponses_api];

export type GetUserInfoData_api = {
    body?: never;
    path: {
        /**
         * User Id Or Email
         *
         * User email, graph-id or 'me' for the authenticated user
         */
        user_id_or_email: string;
    };
    query?: {
        zCacheBust?: string;
    };
    url: "/graph/user_info/{user_id_or_email}";
};

export type GetUserInfoErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetUserInfoError_api = GetUserInfoErrors_api[keyof GetUserInfoErrors_api];

export type GetUserInfoResponses_api = {
    /**
     * Response Get User Info
     *
     * Successful Response
     */
    200: GraphUser_api | null;
};

export type GetUserInfoResponse_api = GetUserInfoResponses_api[keyof GetUserInfoResponses_api];

export type GetUserPhotoData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * User Id Or Email
         *
         * User email, graph-id, or 'me' for the authenticated user
         */
        user_id_or_email: string;
        zCacheBust?: string;
    };
    url: "/graph/user_photo/";
};

export type GetUserPhotoErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetUserPhotoError_api = GetUserPhotoErrors_api[keyof GetUserPhotoErrors_api];

export type GetUserPhotoResponses_api = {
    /**
     * Successful Response
     */
    200: GraphUserPhoto_api;
};

export type GetUserPhotoResponse_api = GetUserPhotoResponses_api[keyof GetUserPhotoResponses_api];

export type GetSummaryObservationsData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Case Uuid
         *
         * Sumo case uuid
         */
        case_uuid: string;
        /**
         * Ensemble Name
         *
         * Ensemble name
         */
        ensemble_name: string;
        zCacheBust?: string;
    };
    url: "/observations/summary_observations";
};

export type GetSummaryObservationsErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetSummaryObservationsError_api = GetSummaryObservationsErrors_api[keyof GetSummaryObservationsErrors_api];

export type GetSummaryObservationsResponses_api = {
    /**
     * Response Get Summary Observations
     *
     * Successful Response
     */
    200: Array<SummaryVectorObservations_api>;
};

export type GetSummaryObservationsResponse_api =
    GetSummaryObservationsResponses_api[keyof GetSummaryObservationsResponses_api];

export type GetRelpermTableNamesData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Case Uuid
         *
         * Sumo case uuid
         */
        case_uuid: string;
        /**
         * Ensemble Name
         *
         * Ensemble name
         */
        ensemble_name: string;
        zCacheBust?: string;
    };
    url: "/relperm/table_names";
};

export type GetRelpermTableNamesErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetRelpermTableNamesError_api = GetRelpermTableNamesErrors_api[keyof GetRelpermTableNamesErrors_api];

export type GetRelpermTableNamesResponses_api = {
    /**
     * Response Get Relperm Table Names
     *
     * Successful Response
     */
    200: Array<string>;
};

export type GetRelpermTableNamesResponse_api =
    GetRelpermTableNamesResponses_api[keyof GetRelpermTableNamesResponses_api];

export type GetRelpermTableDefinitionData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Case Uuid
         *
         * Sumo case uuid
         */
        case_uuid: string;
        /**
         * Ensemble Name
         *
         * Ensemble name
         */
        ensemble_name: string;
        /**
         * Table Name
         *
         * Relperm table name
         */
        table_name: string;
        zCacheBust?: string;
    };
    url: "/relperm/table_definition";
};

export type GetRelpermTableDefinitionErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetRelpermTableDefinitionError_api =
    GetRelpermTableDefinitionErrors_api[keyof GetRelpermTableDefinitionErrors_api];

export type GetRelpermTableDefinitionResponses_api = {
    /**
     * Successful Response
     */
    200: RelpermTableDefinition_api;
};

export type GetRelpermTableDefinitionResponse_api =
    GetRelpermTableDefinitionResponses_api[keyof GetRelpermTableDefinitionResponses_api];

export type GetRelpermRealizationDataData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Case Uuid
         *
         * Sumo case uuid
         */
        case_uuid: string;
        /**
         * Ensemble Name
         *
         * Ensemble name
         */
        ensemble_name: string;
        /**
         * Table Name
         *
         * Relperm table name
         */
        table_name: string;
        /**
         * Saturation Axis Name
         *
         * Saturation axis name
         */
        saturation_axis_name: string;
        /**
         * Curve Names
         *
         * Curve names
         */
        curve_names: Array<string>;
        /**
         * Satnums
         *
         * SATNUM values
         */
        satnums: Array<number>;
        /**
         * Realizations Encoded As Uint List Str
         *
         * Optional list of realizations encoded as string to include. If not specified, all realizations will be included.
         */
        realizations_encoded_as_uint_list_str?: string | null;
        zCacheBust?: string;
    };
    url: "/relperm/realization_data";
};

export type GetRelpermRealizationDataErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetRelpermRealizationDataError_api =
    GetRelpermRealizationDataErrors_api[keyof GetRelpermRealizationDataErrors_api];

export type GetRelpermRealizationDataResponses_api = {
    /**
     * Successful Response
     */
    200: RelpermRealizationDataResponse_api;
};

export type GetRelpermRealizationDataResponse_api =
    GetRelpermRealizationDataResponses_api[keyof GetRelpermRealizationDataResponses_api];

export type GetRftTableDefinitionData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Case Uuid
         *
         * Sumo case uuid
         */
        case_uuid: string;
        /**
         * Ensemble Name
         *
         * Ensemble name
         */
        ensemble_name: string;
        zCacheBust?: string;
    };
    url: "/rft/rft_table_definition";
};

export type GetRftTableDefinitionErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetRftTableDefinitionError_api = GetRftTableDefinitionErrors_api[keyof GetRftTableDefinitionErrors_api];

export type GetRftTableDefinitionResponses_api = {
    /**
     * Successful Response
     */
    200: RftTableDefinition_api;
};

export type GetRftTableDefinitionResponse_api =
    GetRftTableDefinitionResponses_api[keyof GetRftTableDefinitionResponses_api];

export type GetRftRealizationDataData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Case Uuid
         *
         * Sumo case uuid
         */
        case_uuid: string;
        /**
         * Ensemble Name
         *
         * Ensemble name
         */
        ensemble_name: string;
        /**
         * Well Name
         *
         * Well name
         */
        well_name: string;
        /**
         * Response Name
         *
         * Response name
         */
        response_name: string;
        /**
         * Timestamps Utc Ms
         *
         * Timestamps utc ms
         */
        timestamps_utc_ms?: Array<number> | null;
        /**
         * Realizations Encoded As Uint List Str
         *
         * Optional list of realizations encoded as string to include. If not specified, all realizations will be included.
         */
        realizations_encoded_as_uint_list_str?: string | null;
        zCacheBust?: string;
    };
    url: "/rft/rft_realization_data";
};

export type GetRftRealizationDataErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetRftRealizationDataError_api = GetRftRealizationDataErrors_api[keyof GetRftRealizationDataErrors_api];

export type GetRftRealizationDataResponses_api = {
    /**
     * Response Get Rft Realization Data
     *
     * Successful Response
     */
    200: Array<RftRealizationData_api>;
};

export type GetRftRealizationDataResponse_api =
    GetRftRealizationDataResponses_api[keyof GetRftRealizationDataResponses_api];

export type GetRftObservationsData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Case Uuid
         *
         * Sumo case uuid
         */
        case_uuid: string;
        /**
         * Ensemble Name
         *
         * Ensemble name
         */
        ensemble_name: string;
        zCacheBust?: string;
    };
    url: "/rft/rft_observations";
};

export type GetRftObservationsErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetRftObservationsError_api = GetRftObservationsErrors_api[keyof GetRftObservationsErrors_api];

export type GetRftObservationsResponses_api = {
    /**
     * Response Get Rft Observations
     *
     * Successful Response
     */
    200: Array<RftObservations_api>;
};

export type GetRftObservationsResponse_api = GetRftObservationsResponses_api[keyof GetRftObservationsResponses_api];

export type GetVfpTablesData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Case Uuid
         *
         * Sumo case uuid
         */
        case_uuid: string;
        /**
         * Ensemble Name
         *
         * Ensemble name
         */
        ensemble_name: string;
        /**
         * Realization
         *
         * Realization
         */
        realization: number;
        zCacheBust?: string;
    };
    url: "/vfp/vfp_tables/";
};

export type GetVfpTablesErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetVfpTablesError_api = GetVfpTablesErrors_api[keyof GetVfpTablesErrors_api];

export type GetVfpTablesResponses_api = {
    /**
     * Response Get Vfp Tables
     *
     * Successful Response
     */
    200: Array<VfpTableInfo_api>;
};

export type GetVfpTablesResponse_api = GetVfpTablesResponses_api[keyof GetVfpTablesResponses_api];

export type GetVfpTableData_api = {
    body?: never;
    path?: never;
    query: {
        /**
         * Case Uuid
         *
         * Sumo case uuid
         */
        case_uuid: string;
        /**
         * Ensemble Name
         *
         * Ensemble name
         */
        ensemble_name: string;
        /**
         * Realization
         *
         * Realization
         */
        realization: number;
        /**
         * VFP table type
         */
        vfp_type: VfpType_api;
        /**
         * Vfp Table Number
         *
         * VFP table number
         */
        vfp_table_number: number;
        zCacheBust?: string;
    };
    url: "/vfp/vfp_table/";
};

export type GetVfpTableErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetVfpTableError_api = GetVfpTableErrors_api[keyof GetVfpTableErrors_api];

export type GetVfpTableResponses_api = {
    /**
     * Response Get Vfp Table
     *
     * Successful Response
     */
    200: VfpProdTable_api | VfpInjTable_api;
};

export type GetVfpTableResponse_api = GetVfpTableResponses_api[keyof GetVfpTableResponses_api];

export type GetSessionsMetadataData_api = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Cursor
         *
         * Continuation token for pagination
         */
        cursor?: string | null;
        /**
         * Sort By
         *
         * Field to sort by (e.g., 'metadata.title')
         */
        sort_by?: SessionSortBy_api | null;
        /**
         * Sort Direction
         *
         * Sort direction: 'asc' or 'desc'
         */
        sort_direction?: SortDirection_api | null;
        /**
         * Sort Lowercase
         *
         * Use case-insensitive sorting
         */
        sort_lowercase?: boolean;
        /**
         * Page Size
         *
         * Limit the number of results
         */
        page_size?: number;
        /**
         * Filter Title
         *
         * Filter results by title (case insensitive)
         */
        filter_title?: string | null;
        /**
         * Filter Updated From
         *
         * Filter results by date
         */
        filter_updated_from?: string | null;
        /**
         * Filter Updated To
         *
         * Filter results by date
         */
        filter_updated_to?: string | null;
        zCacheBust?: string;
    };
    url: "/persistence/sessions";
};

export type GetSessionsMetadataErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetSessionsMetadataError_api = GetSessionsMetadataErrors_api[keyof GetSessionsMetadataErrors_api];

export type GetSessionsMetadataResponses_api = {
    /**
     * Successful Response
     */
    200: PageSessionMetadata_api;
};

export type GetSessionsMetadataResponse_api = GetSessionsMetadataResponses_api[keyof GetSessionsMetadataResponses_api];

export type CreateSessionData_api = {
    body: NewSession_api;
    path?: never;
    query?: {
        zCacheBust?: string;
    };
    url: "/persistence/sessions";
};

export type CreateSessionErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type CreateSessionError_api = CreateSessionErrors_api[keyof CreateSessionErrors_api];

export type CreateSessionResponses_api = {
    /**
     * Response Create Session
     *
     * Successful Response
     */
    200: string;
};

export type CreateSessionResponse_api = CreateSessionResponses_api[keyof CreateSessionResponses_api];

export type DeleteSessionData_api = {
    body?: never;
    path: {
        /**
         * Session Id
         */
        session_id: string;
    };
    query?: {
        zCacheBust?: string;
    };
    url: "/persistence/sessions/{session_id}";
};

export type DeleteSessionErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type DeleteSessionError_api = DeleteSessionErrors_api[keyof DeleteSessionErrors_api];

export type DeleteSessionResponses_api = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type GetSessionData_api = {
    body?: never;
    path: {
        /**
         * Session Id
         */
        session_id: string;
    };
    query?: {
        zCacheBust?: string;
    };
    url: "/persistence/sessions/{session_id}";
};

export type GetSessionErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetSessionError_api = GetSessionErrors_api[keyof GetSessionErrors_api];

export type GetSessionResponses_api = {
    /**
     * Successful Response
     */
    200: Session_api;
};

export type GetSessionResponse_api = GetSessionResponses_api[keyof GetSessionResponses_api];

export type UpdateSessionData_api = {
    body: SessionUpdate_api;
    path: {
        /**
         * Session Id
         */
        session_id: string;
    };
    query?: {
        zCacheBust?: string;
    };
    url: "/persistence/sessions/{session_id}";
};

export type UpdateSessionErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type UpdateSessionError_api = UpdateSessionErrors_api[keyof UpdateSessionErrors_api];

export type UpdateSessionResponses_api = {
    /**
     * Successful Response
     */
    200: Session_api;
};

export type UpdateSessionResponse_api = UpdateSessionResponses_api[keyof UpdateSessionResponses_api];

export type GetSessionMetadataData_api = {
    body?: never;
    path: {
        /**
         * Session Id
         */
        session_id: string;
    };
    query?: {
        zCacheBust?: string;
    };
    url: "/persistence/sessions/metadata/{session_id}";
};

export type GetSessionMetadataErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetSessionMetadataError_api = GetSessionMetadataErrors_api[keyof GetSessionMetadataErrors_api];

export type GetSessionMetadataResponses_api = {
    /**
     * Successful Response
     */
    200: SessionMetadata_api;
};

export type GetSessionMetadataResponse_api = GetSessionMetadataResponses_api[keyof GetSessionMetadataResponses_api];

export type GetSnapshotAccessLogsData_api = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Cursor
         *
         * Continuation token for pagination
         */
        cursor?: string | null;
        /**
         * Page Size
         *
         * Limit the number of results
         */
        page_size?: number | null;
        /**
         * Sort By
         *
         * Sort the result by
         */
        sort_by?: SnapshotAccessLogSortBy_api | null;
        /**
         * Sort Direction
         *
         * Sort direction: 'asc' or 'desc'
         */
        sort_direction?: SortDirection_api | null;
        /**
         * Sort Lowercase
         *
         * Use case-insensitive sorting
         */
        sort_lowercase?: boolean;
        /**
         * Filter Title
         *
         * Filter results by title (case insensitive)
         */
        filter_title?: string | null;
        /**
         * Filter Created From
         *
         * Filter results by date
         */
        filter_created_from?: string | null;
        /**
         * Filter Created To
         *
         * Filter results by date
         */
        filter_created_to?: string | null;
        /**
         * Filter Last Visited From
         *
         * Filter results by date of last visit
         */
        filter_last_visited_from?: string | null;
        /**
         * Filter Last Visited To
         *
         * Filter results by date of last visit
         */
        filter_last_visited_to?: string | null;
        /**
         * Filter Owner Id
         *
         * Filter results by snapshot owner ID
         */
        filter_owner_id?: string | null;
        /**
         * Filter Snapshot Deleted
         *
         * Filter results by deletion status of the snapshot
         */
        filter_snapshot_deleted?: boolean | null;
        zCacheBust?: string;
    };
    url: "/persistence/snapshot_access_logs";
};

export type GetSnapshotAccessLogsErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetSnapshotAccessLogsError_api = GetSnapshotAccessLogsErrors_api[keyof GetSnapshotAccessLogsErrors_api];

export type GetSnapshotAccessLogsResponses_api = {
    /**
     * Successful Response
     */
    200: PageSnapshotAccessLog_api;
};

export type GetSnapshotAccessLogsResponse_api =
    GetSnapshotAccessLogsResponses_api[keyof GetSnapshotAccessLogsResponses_api];

export type GetSnapshotsMetadataData_api = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Cursor
         *
         * Continuation token for pagination
         */
        cursor?: string | null;
        /**
         * Page Size
         *
         * Limit the number of results
         */
        page_size?: number | null;
        /**
         * Sort By
         *
         * Sort the result by
         */
        sort_by?: SnapshotSortBy_api | null;
        /**
         * Sort Direction
         *
         * Sort direction: 'asc' or 'desc'
         */
        sort_direction?: SortDirection_api | null;
        /**
         * Sort Lowercase
         *
         * Use case-insensitive sorting
         */
        sort_lowercase?: boolean;
        /**
         * Filter Title
         *
         * Filter results by title (case insensitive)
         */
        filter_title?: string | null;
        /**
         * Filter Created From
         *
         * Filter results by date
         */
        filter_created_from?: string | null;
        /**
         * Filter Created To
         *
         * Filter results by date
         */
        filter_created_to?: string | null;
        zCacheBust?: string;
    };
    url: "/persistence/snapshots";
};

export type GetSnapshotsMetadataErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetSnapshotsMetadataError_api = GetSnapshotsMetadataErrors_api[keyof GetSnapshotsMetadataErrors_api];

export type GetSnapshotsMetadataResponses_api = {
    /**
     * Successful Response
     */
    200: PageSnapshotMetadata_api;
};

export type GetSnapshotsMetadataResponse_api =
    GetSnapshotsMetadataResponses_api[keyof GetSnapshotsMetadataResponses_api];

export type CreateSnapshotData_api = {
    body: NewSnapshot_api;
    path?: never;
    query?: {
        zCacheBust?: string;
    };
    url: "/persistence/snapshots";
};

export type CreateSnapshotErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type CreateSnapshotError_api = CreateSnapshotErrors_api[keyof CreateSnapshotErrors_api];

export type CreateSnapshotResponses_api = {
    /**
     * Response Create Snapshot
     *
     * Successful Response
     */
    200: string;
};

export type CreateSnapshotResponse_api = CreateSnapshotResponses_api[keyof CreateSnapshotResponses_api];

export type DeleteSnapshotData_api = {
    body?: never;
    path: {
        /**
         * Snapshot Id
         */
        snapshot_id: string;
    };
    query?: {
        zCacheBust?: string;
    };
    url: "/persistence/snapshots/{snapshot_id}";
};

export type DeleteSnapshotErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type DeleteSnapshotError_api = DeleteSnapshotErrors_api[keyof DeleteSnapshotErrors_api];

export type DeleteSnapshotResponses_api = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type GetSnapshotData_api = {
    body?: never;
    path: {
        /**
         * Snapshot Id
         */
        snapshot_id: string;
    };
    query?: {
        zCacheBust?: string;
    };
    url: "/persistence/snapshots/{snapshot_id}";
};

export type GetSnapshotErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetSnapshotError_api = GetSnapshotErrors_api[keyof GetSnapshotErrors_api];

export type GetSnapshotResponses_api = {
    /**
     * Successful Response
     */
    200: Snapshot_api;
};

export type GetSnapshotResponse_api = GetSnapshotResponses_api[keyof GetSnapshotResponses_api];

export type DeleteSnapshotAccessLogData_api = {
    body?: never;
    path: {
        /**
         * Snapshot Id
         */
        snapshot_id: string;
    };
    query?: {
        zCacheBust?: string;
    };
    url: "/persistence/snapshot_access_logs/{snapshot_id}";
};

export type DeleteSnapshotAccessLogErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type DeleteSnapshotAccessLogError_api =
    DeleteSnapshotAccessLogErrors_api[keyof DeleteSnapshotAccessLogErrors_api];

export type DeleteSnapshotAccessLogResponses_api = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type GetMediaSasTokenData_api = {
    body?: never;
    path?: never;
    query?: {
        zCacheBust?: string;
    };
    url: "/tutorials/media_sas_token";
};

export type GetMediaSasTokenResponses_api = {
    /**
     * Successful Response
     */
    200: TutorialMediaSasToken_api;
};

export type GetMediaSasTokenResponse_api = GetMediaSasTokenResponses_api[keyof GetMediaSasTokenResponses_api];

export type LoginRouteData_api = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Redirect Url After Login
         */
        redirect_url_after_login?: string | null;
        zCacheBust?: string;
    };
    url: "/login";
};

export type LoginRouteErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type LoginRouteError_api = LoginRouteErrors_api[keyof LoginRouteErrors_api];

export type LoginRouteResponses_api = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type AuthorizedCallbackRouteData_api = {
    body?: never;
    path?: never;
    query?: {
        zCacheBust?: string;
    };
    url: "/auth-callback";
};

export type AuthorizedCallbackRouteResponses_api = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type GetAliveData_api = {
    body?: never;
    path?: never;
    query?: {
        zCacheBust?: string;
    };
    url: "/alive";
};

export type GetAliveResponses_api = {
    /**
     * Response Get Alive
     *
     * Successful Response
     */
    200: string;
};

export type GetAliveResponse_api = GetAliveResponses_api[keyof GetAliveResponses_api];

export type GetAliveProtectedData_api = {
    body?: never;
    path?: never;
    query?: {
        zCacheBust?: string;
    };
    url: "/alive_protected";
};

export type GetAliveProtectedResponses_api = {
    /**
     * Response Get Alive Protected
     *
     * Successful Response
     */
    200: string;
};

export type GetAliveProtectedResponse_api = GetAliveProtectedResponses_api[keyof GetAliveProtectedResponses_api];

export type PostLogoutData_api = {
    body?: never;
    path?: never;
    query?: {
        zCacheBust?: string;
    };
    url: "/logout";
};

export type PostLogoutResponses_api = {
    /**
     * Response Post Logout
     *
     * Successful Response
     */
    200: string;
};

export type PostLogoutResponse_api = PostLogoutResponses_api[keyof PostLogoutResponses_api];

export type GetLoggedInUserData_api = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Includegraphapiinfo
         *
         * Set to true to include user avatar and display name from Microsoft Graph API
         */
        includeGraphApiInfo?: boolean;
        zCacheBust?: string;
    };
    url: "/logged_in_user";
};

export type GetLoggedInUserErrors_api = {
    /**
     * Validation Error
     */
    422: HTTPValidationError_api;
};

export type GetLoggedInUserError_api = GetLoggedInUserErrors_api[keyof GetLoggedInUserErrors_api];

export type GetLoggedInUserResponses_api = {
    /**
     * Successful Response
     */
    200: UserInfo_api;
};

export type GetLoggedInUserResponse_api = GetLoggedInUserResponses_api[keyof GetLoggedInUserResponses_api];

export type RootData_api = {
    body?: never;
    path?: never;
    query?: {
        zCacheBust?: string;
    };
    url: "/";
};

export type RootResponses_api = {
    /**
     * Response Root
     *
     * Successful Response
     */
    200: string;
};

export type RootResponse_api = RootResponses_api[keyof RootResponses_api];
